import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import * as LayoutComponents from '../Shared/LayoutComponents.js'
import CommentsList from '../Shared/CommentsList/CommentsList.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";
import '../Shared/Style.css';
import Attachments from "../Shared/Attachments.js";
import { useDropzone } from 'react-dropzone';
import MultiSelectField from "../Shared/MultiSelectField.js"
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";
import Submissions from "../Submissions/Submissions.js";
import ProductTreeSelector from "./ProductTreeSelector.js";
import "./App.css";

import $ from "jquery";

import "trumbowyg/dist/ui/trumbowyg.min.css";



const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [isShowingConfirmSavePopup, setIsShowingConfirmSavePopup] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [requestingTranslation, setRequestingTranslation] = useState(false);
    const [requestedTranslation, setRequestedTranslation] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");
    const [selectedPDFVersion, setSelectedPDFVersion] = useState(null);
    const [isVersionDropdownOpen, setIsVersionDropdownOpen] = React.useState(false);
    const [productFamilies, setProductFamilies] = useState([]);
    const [countries, setCountries] = useState([]);
    const [countryRepresentatives, setCountryRepresentatives] = useState([]);
    const [countryDistributors, setCountryDistributors] = useState([]);
    const [importers, setImporters] = useState([]);
    const [legalManufacturers, setLegalManufacturers] = useState([]);
    const [physicalManufacturers, setPhysicalManufacturers] = useState([]);
    const [sppp, setSPPP] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [version, setVersion] = useState(0);
    const [documentListRefresh, setDocumentListRefresh] = useState(0);

    const [isEditingField, setIsEditingField] = useState({
        SKUProductCode: false,
        ProductName: false,
        FamilyName: false,
    });

    const [errorCurrentItem, setErrorCurrentItem] = useState(false);

    const [isSavingItemNotes, setIsSavingItemNotes] = useState(false);
    const [isSavingItemEdit, setIsSavingItemEdit] = useState(false);
    const [isSavingItemAssignPriorityAlerts, setIsSavingItemAssignPriorityAlerts] = useState(false);
    const [isSavingItemBulkUpdates, setIsSavingItemBulkUpdates] = useState(false);

    const [localCurrentItem, setLocalCurrentItem] = useState({ Priority: -1, AssignedTo: -1, Status: -1, ExpiryDate: null, Selling: -1 });


    const [isShowingSaveMessageNotes, setIsShowingSaveMessageNotes] = useState(false);
    const [isShowingSaveMessageEdit, setIsShowingSaveMessageEdit] = useState(false);
    const [isShowingSaveMessageAssignPriorityAlerts, setIsShowingSaveMessageAssignPriorityAlerts] = useState(false);
    const [isShowingSaveMessageBulkUpdates, setIsShowingSaveMessageBulkUpdates] = useState(false);

    const [isShowingDocumentAddPopup, setIsShowingDocumentAddPopup] = useState(false);
    const [isShowingAddProductsToCertificatePopup, setIsShowingAddProductsToCertificatePopup] = useState(false);
    const [isShowingBulkUpdatesPopup, setIsShowingBulkUpdatesPopup] = useState(false);
    const [registrationsIdsSelected, setRegistrationsIdsSelected] = useState([]);


    const [addProductIds, setAddProductIds] = useState([]);
    const [isAddingProductsToCertificate, setIsAddingProductsToCertificate] = useState(false);
    const [addedProductsToCertificate, setAddedProductsToCertificate] = useState(false);

    const [errorAddIssued, setErrorAddIssued] = useState(false);
    const [errorAddRiskClass, setErrorAddRiskClass] = useState(false);
    const [errorAddRegistrationStatus, setErrorAddRegistrationStatus] = useState(false);
    const [errorAddSelling, setErrorAddSelling] = useState(false);
    const [errorAddAssigned, setErrorAddAssigned] = useState(false);
    const [errorAddPriority, setErrorAddPriority] = useState(false);
    const [errorAddExpiryDate, setErrorAddExpiryDate] = useState(false);
    const [errorAddingItem, setErrorAddingItem] = useState(null);

    const [addIssued, setAddIssued] = useState(null);
    const [addRiskClass, setAddRiskClass] = useState(null);
    const [addRegistrationStatus, setAddRegistrationStatus] = useState(null);
    const [addSelling, setAddSelling] = useState(null);
    const [addAssigned, setAddAssigned] = useState(null);
    const [addPriority, setAddPriority] = useState(null);
    const [addExpiryDate, setAddExpiryDate] = useState(null);

    const [field_DISTRIBUTORS, setField_DISTRIBUTORS] = useState({});
    const [fieldConfig_DISTRIBUTORS, setFieldConfig_DISTRIBUTORS] = useState([]);
    const [formState_DISTRIBUTORS, setFormState_DISTRIBUTORS] = useState({});

    const [field_IMPORTERS, setField_IMPORTERS] = useState({});
    const [fieldConfig_IMPORTERS, setFieldConfig_IMPORTERS] = useState([]);
    const [formState_IMPORTERS, setFormState_IMPORTERS] = useState({});

    const [field_REPRESENTATIVES, setField_REPRESENTATIVES] = useState({});
    const [fieldConfig_REPRESENTATIVES, setFieldConfig_REPRESENTATIVES] = useState([]);
    const [formState_REPRESENTATIVES, setFormState_REPRESENTATIVES] = useState({});

    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [errorNoProducts, setErrorNoProducts] = useState(false);

    const [registrationListRefresh, setRegistrationListRefresh] = useState(0);


    const [isBulkUpdateFieldActivatedStatus, setIsBulkUpdateFieldActivatedStatus] = useState(false);
    const [isBulkUpdateFieldActivatedRiskClass, setIsBulkUpdateFieldActivatedRiskClass] = useState(false);
    const [isBulkUpdateFieldActivatedExpiryDate, setIsBulkUpdateFieldActivatedExpiryDate] = useState(false);
    const [isBulkUpdateFieldActivatedSelling, setIsBulkUpdateFieldActivatedSelling] = useState(false);
    const [isBulkUpdateFieldActivatedAssignedTo, setIsBulkUpdateFieldActivatedAssignedTo] = useState(false);
    const [isBulkUpdateFieldActivatedMonths, setIsBulkUpdateFieldActivatedMonths] = useState(false);
    const [isBulkUpdateFieldActivatedPriority, setIsBulkUpdateFieldActivatedPriority] = useState(false);
    const [isBulkUpdateFieldActivatedIssuedBy, setIsBulkUpdateFieldActivatedIssuedBy] = useState(false);
    const [isBulkUpdateFieldActivatedDistributors, setIsBulkUpdateFieldActivatedDistributors] = useState(false);
    const [isBulkUpdateFieldActivatedRepresentatives, setIsBulkUpdateFieldActivatedRepresentatives] = useState(false);
    const [isBulkUpdateFieldActivatedImporters, setIsBulkUpdateFieldActivatedImporters] = useState(false);
    const hasActiveBulkUpdates =
        isBulkUpdateFieldActivatedStatus ||
        isBulkUpdateFieldActivatedRiskClass ||
        isBulkUpdateFieldActivatedExpiryDate ||
        isBulkUpdateFieldActivatedSelling ||
        isBulkUpdateFieldActivatedAssignedTo ||
        isBulkUpdateFieldActivatedMonths ||
        isBulkUpdateFieldActivatedPriority ||
        isBulkUpdateFieldActivatedIssuedBy ||
        isBulkUpdateFieldActivatedDistributors ||
        isBulkUpdateFieldActivatedRepresentatives ||
        isBulkUpdateFieldActivatedImporters;

    const [errorBulk, setErrorBulk] = useState(false);

    const [appContextBulkObject, setAppContextBulkObject] = useState({});

    const [isEditModeNote, setIsEditModeNote] = useState(false);

    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);
    const currentItemSKUProductCodeRef = useRef(null);
    const currentItemProductNameRef = useRef(null);

    const dropdownRefs = useRef({});


    const openAddProductsToCertificatePopup = () => {
        setIsShowingAddProductsToCertificatePopup(true);
    }

    const openBulkUpdatesPopup = (selectedIds) => {

        setIsShowingSaveMessageBulkUpdates(false);
        setIsShowingBulkUpdatesPopup(true);
        setRegistrationsIdsSelected(selectedIds);
    }


    const openDocumentPopup = () => {
        setIsShowingDocumentAddPopup(true);
    }

    const closeDocumentPopup = () => {
        setIsShowingDocumentAddPopup(false);
    }

    const successDocumentUploaded = () => {
        setDocumentListRefresh(prev => prev + 1);
    }

    const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

    const hasValue = (val) => {
        return val !== "" && val !== null;
    }



    function stringifyIfObject(value) {
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value);
        }
        return value;
    }



    const validFormField = (field, errorFunc) => {
        if (field === "" || field === null) {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    useEffect(() => {

        if (isShowingAddProductsToCertificatePopup) {

            // did it load the operators yet?

            let alreadyLoaded = field_IMPORTERS.Items?.length > 0 || field_REPRESENTATIVES.Items?.length > 0 || field_DISTRIBUTORS.Items?.length > 0;

            if (!alreadyLoaded) {
                loadOperators();
            }

            setAddIssued(AppContext.currentItem.IssuedBy);
            setAddRiskClass(AppContext.currentItem.RiskClass);
            setAddRegistrationStatus(AppContext.currentItem.Status);
            setAddSelling(AppContext.currentItem.Selling);
            setAddAssigned(AppContext.currentItem.AssignedTo);
            setAddPriority(AppContext.currentItem.Priority);
            setAddExpiryDate(AppContext.currentItem.ExpiryDate?.split("T")[0]);

            setIsAddingProductsToCertificate(false);
            setAddedProductsToCertificate(false);
            resetErrors();

        }

    }, [isShowingAddProductsToCertificatePopup]);







    const loadOperators = (preserveSelection = false) => {

        let url = "/umbraco/api/ProductRegistrationsApi/OperatorsGroupedByRole";

        let requestOptions = {};

        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Importers

                let importers = { Alias: "importers", Name: "Importers", Items: [] };

                importers.Items = data.importers.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_IMPORTERS(importers);
                setFieldConfig_IMPORTERS([importers]);
                if (!preserveSelection)
                    setFormState_IMPORTERS({ importers: AppContext.currentItem.ImportersIds ?? [] });

                // Representatives

                let representatives = { Alias: "representatives", Name: "Representatives", Items: [] };

                representatives.Items = data.representatives.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_REPRESENTATIVES(representatives);
                setFieldConfig_REPRESENTATIVES([representatives]);
                if (!preserveSelection)
                    setFormState_REPRESENTATIVES({ representatives: AppContext.currentItem.CountryRepresentativesIds ?? [] });


                // Distributors

                let distributors = { Alias: "distributors", Name: "Distributors", Items: [] };

                distributors.Items = data.distributors.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_DISTRIBUTORS(distributors);
                setFieldConfig_DISTRIBUTORS([distributors]);
                if (!preserveSelection)
                    setFormState_DISTRIBUTORS({ distributors: AppContext.currentItem.CountryDistributorsIds ?? [] });


            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }







    const loadCountryRepresentatives = () => {

        let countryRepresentativeRoleId = 3;
        return loadOperatorsType(countryRepresentativeRoleId, setCountryRepresentatives);
    };

    const loadCountryDistributors = () => {

        let countryDistributorRoleId = 4;
        return loadOperatorsType(countryDistributorRoleId, setCountryDistributors);
    };

    const loadImporters = () => {

        let importerRoleId = 2;
        return loadOperatorsType(importerRoleId, setImporters);
    };

    const loadLegalManufacturers = () => {

        let legalManufacturerRoleId = 1;
        loadOperatorsType(legalManufacturerRoleId, setLegalManufacturers);
    };






    const loadOperatorsType = (roleId, setFunction) => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Operators?roleId=" + roleId;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        return fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) setFunction(result);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });

    }




    const resetErrors = () => {

        setErrorAddRiskClass(false);
        setErrorAddSelling(false);
        setErrorAddRegistrationStatus(false);
        setErrorAddPriority(false);
        setErrorNoProducts(false);

        setErrorAddingItem(null);

    }



    const addProductsToCertificate = () => {

        let isValidForm = true;

        setIsAddingProductsToCertificate(false);
        setAddedProductsToCertificate(false);
        resetErrors();

        if (!validFormField(addRiskClass, setErrorAddRiskClass))
            isValidForm = false;
        if (!validFormField(addSelling, setErrorAddSelling))
            isValidForm = false;
        if (!validFormField(addRegistrationStatus, setErrorAddRegistrationStatus))
            isValidForm = false;
        if (!validFormField(addPriority, setErrorAddPriority))
            isValidForm = false;

        if (addProductIds.length == 0) {
            setErrorNoProducts(true);
            isValidForm = false;
        }

        if (!isValidForm) {
            setErrorAddingItem("Risk Class, Selling, Status, Priority and Products can't be empty");
            return false;
        }


        setIsAddingProductsToCertificate(true);
        setAddedProductsToCertificate(false);

        let addProductsURL = "/umbraco/api/RIMSRegistrations/CertificateRegistrations/";

        let data = {
            Id: AppContext.currentItem.Id,
            RegistrationCount: 0,
            ProductIds: addProductIds,
            RiskClass: addRiskClass,
            Status: addRegistrationStatus,
            IssuedBy: addIssued,
            CountryId: AppContext.currentItem.CountryId,
            Name: AppContext.currentItem.Name,
            ExpiryDate: addExpiryDate,
            Selling: addSelling,
            AssignedTo: addAssigned ? [parseInt(addAssigned)] : null,
            Priority: addPriority,
            ImportersIds: formState_IMPORTERS["importers"],
            CountryRepresentativesIds: formState_REPRESENTATIVES["representatives"],
            CountryDistributorsIds: formState_DISTRIBUTORS["distributors"]
        };

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        };

        fetch(addProductsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json().catch(() => null);
            })
            .then((result) => {

                setAddedProductsToCertificate(true);
                setRegistrationListRefresh(prev => prev + 1);

                // Refresh certificate so newly linked legal manufacturers appear
                if (result && result.Id) {
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);
                    AppContext.setCurrentItem(result);
                    AppContext.setOriginalItem(result);
                } else {
                    fetch(`/umbraco/api/RIMSRegistrations/Certificate/?id=${AppContext.currentItem.Id}`)
                        .then((r) => r.ok ? r.json() : null)
                        .then((cert) => {
                            if (!cert || !cert.Id) return;
                            const updatedDataArray = AppContext.data.map((item) =>
                                item.Id === cert.Id ? cert : item
                            );
                            AppContext.setData(updatedDataArray);
                            AppContext.setCurrentItem(cert);
                            AppContext.setOriginalItem(cert);
                        })
                        .catch(() => { });
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingProductsToCertificate(false);
            });



    }




    const saveCurrentItem = ({ bulkSaveToRegistrations = false }) => {

        // Validations


        let isValidForm = true;

        setErrorCurrentItem(false);


        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        setIsSavingItemBulkUpdates(true);
        setIsShowingSaveMessageBulkUpdates(false);
        AppContext.disableAllItemFormFieldsEdit();

        let updateItemURL = AppContext.dataUrl;

        if (bulkSaveToRegistrations)
            updateItemURL += "?bulk=true&";

        const updatedItem = structuredClone(AppContext.currentItem);

        // Note is updated in another method, here use the default value
        updatedItem.Note = AppContext.originalItem.Note;

        if (!Array.isArray(updatedItem.AssignedTo))
            if (updatedItem.AssignedTo == null)
                updatedItem.AssignedTo = [];
            else
                updatedItem.AssignedTo = [updatedItem.AssignedTo];


        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);

                    AppContext.setCurrentItem(result);
                    AppContext.setOriginalItem(result);

                    setIsEditMode(false);

                    setIsShowingSaveMessageBulkUpdates(true);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
                setIsSavingItemBulkUpdates(false);
            });


    }


    const saveCurrentItemPartial = (part) => {
        // Validations


        let isValidForm = true;

        setErrorCurrentItem(false);


        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();


        setIsShowingSaveMessageNotes(false);
        setIsShowingSaveMessageEdit(false);
        setIsShowingSaveMessageAssignPriorityAlerts(false);
        setIsShowingSaveMessageBulkUpdates(false);




        const updatedItem = structuredClone(AppContext.currentItem);


        let updateItemURL = "";
        let method = "PATCH";

        if (part == "notes") {
            updateItemURL = "/umbraco/api/RIMSRegistrations/OpCertNotes/";
            setIsSavingItemNotes(true);
        }
        if (part == "edit") {
            updateItemURL = "/umbraco/api/RIMSRegistrations/Certificates/";
            method = "PUT";
            setIsSavingItemEdit(true);
        }
        if (part == "assign-priority-alerts") {
            updateItemURL = "/umbraco/api/RIMSRegistrations/OpCertAlerts/";

            updatedItem.AssignedTo = localCurrentItem.AssignedTo != -1 ? [localCurrentItem.AssignedTo] : null;
            updatedItem.Priority = localCurrentItem.Priority != -1 ? localCurrentItem.Priority : null;
            //updatedItem.Months = localCurrentItem.Months ? localCurrentItem.Months : null;

            setIsSavingItemAssignPriorityAlerts(true);
        }
        if (part == "bulk-updates") {
            updateItemURL = "/umbraco/api/RIMSRegistrations/CertificateBulkUpdate/";
            setIsSavingItemBulkUpdates(true);

            updatedItem.Status = appContextBulkObject.currentItem.Status != -1 ? appContextBulkObject.currentItem.Status : null;
            updatedItem.ExpiryDate = appContextBulkObject.currentItem.ExpiryDate;
            updatedItem.Selling = appContextBulkObject.currentItem.Selling != -1 ? appContextBulkObject.currentItem.Selling : null;
            updatedItem.AssignedTo = appContextBulkObject.currentItem.AssignedTo != -1 ? [appContextBulkObject.currentItem.AssignedTo] : null;
            updatedItem.Priority = appContextBulkObject.currentItem.Priority != -1 ? appContextBulkObject.currentItem.Priority : null;
            updatedItem.Months = appContextBulkObject.currentItem.Months ? appContextBulkObject.currentItem.Months : null;
         
        }



        let requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);


                    // Update current item

                    let objectPartlyUpdated = AppContext.currentItem;

                    if (part == "notes") {
                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            Notes: result.Notes
                        };

                        setIsEditModeNote(false);

                        setIsShowingSaveMessageNotes(true);
                    }


                    if (part == "edit") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            Name: result.Name,
                            CountryId: result.CountryId,
                            CountryName: result.CountryName,
                            Roles: result.Roles,
                            Authority: result.Authority,
                        };

                        setIsShowingSaveMessageEdit(true);
                    }


                    if (part == "assign-priority-alerts") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            AssignedTo: result.AssignedTo,
                            Priority: result.Priority,
                            Months: result.Months,
                        };

                        setIsShowingSaveMessageAssignPriorityAlerts(true);
                    }


                    if (part == "bulk-updates") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            Status: result.Status,
                            ExpiryDate: result.ExpiryDate,
                            Selling: result.Selling,
                        };

                        setIsShowingSaveMessageBulkUpdates(true);

                        // update the registrations list
                        setRegistrationListRefresh(prev => prev + 1);
                    }


                    AppContext.setCurrentItem(objectPartlyUpdated);




                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItemNotes(false);
                setIsSavingItemEdit(false);
                setIsSavingItemAssignPriorityAlerts(false);
                setIsSavingItemBulkUpdates(false);

                setIsSavingItem(false);
            });
    };






    const saveRegistrationsBulkChanges = () => {
        // Validations


        let isValidForm = true;

        setErrorBulk(false);
        

        let updateItemURL = "/umbraco/api/RIMSRegistrations/CertificateBulkUpdate/";
        let method = "PATCH";

        let updatedItem = AppContext.originalItem;


        updatedItem = { ...updatedItem, Status: null };
        updatedItem = { ...updatedItem, RiskClass: null };
        updatedItem = { ...updatedItem, ExpiryDate: null };
        updatedItem = { ...updatedItem, Selling: null };
        updatedItem = { ...updatedItem, AssignedTo: null };
        updatedItem = { ...updatedItem, Priority: null };
        updatedItem = { ...updatedItem, Months: -1 };
        updatedItem = { ...updatedItem, IssuedBy: null };
        updatedItem = { ...updatedItem, CountryDistributorsIds: null };
        updatedItem = { ...updatedItem, CountryRepresentativesIds: null };
        updatedItem = { ...updatedItem, ImportersIds: null };
        updatedItem = { ...updatedItem, RegistrationsIds: null };

        if (isBulkUpdateFieldActivatedAssignedTo && (!appContextBulkObject.currentItem.AssignedTo || Array.isArray(appContextBulkObject.currentItem.AssignedTo)))
            isValidForm = false;

        if (!isValidForm) {
            setErrorBulk(true);
            return;
        }


        if (isBulkUpdateFieldActivatedStatus) updatedItem = { ...updatedItem, Status: appContextBulkObject.currentItem.Status };
        if (isBulkUpdateFieldActivatedRiskClass) updatedItem = { ...updatedItem, RiskClass: appContextBulkObject.currentItem.RiskClass };
        if (isBulkUpdateFieldActivatedExpiryDate) updatedItem = { ...updatedItem, ExpiryDate: appContextBulkObject.currentItem.ExpiryDate };
        if (isBulkUpdateFieldActivatedSelling) updatedItem = { ...updatedItem, Selling: appContextBulkObject.currentItem.Selling };
        if (isBulkUpdateFieldActivatedAssignedTo) updatedItem = { ...updatedItem, AssignedTo: [appContextBulkObject.currentItem.AssignedTo] };
        if (isBulkUpdateFieldActivatedPriority) updatedItem = { ...updatedItem, Priority: appContextBulkObject.currentItem.Priority };
        if (isBulkUpdateFieldActivatedMonths) updatedItem = { ...updatedItem, Months: appContextBulkObject.currentItem.Months };
        if (isBulkUpdateFieldActivatedIssuedBy) updatedItem = { ...updatedItem, IssuedBy: appContextBulkObject.currentItem.IssuedBy };
        if (isBulkUpdateFieldActivatedDistributors) updatedItem = { ...updatedItem, CountryDistributorsIds: appContextBulkObject.currentItem.CountryDistributorsIds };
        if (isBulkUpdateFieldActivatedRepresentatives) updatedItem = { ...updatedItem, CountryRepresentativesIds: appContextBulkObject.currentItem.CountryRepresentativesIds };
        if (isBulkUpdateFieldActivatedImporters) updatedItem = { ...updatedItem, ImportersIds: appContextBulkObject.currentItem.ImportersIds };

        updatedItem.RegistrationsIds = registrationsIdsSelected;

        setIsSavingItemBulkUpdates(true);
        setIsShowingSaveMessageBulkUpdates(false);


        let requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setIsShowingSaveMessageBulkUpdates(true);

                // update the registrations list
                setRegistrationListRefresh(prev => prev + 1);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItemBulkUpdates(false);
            });
    };









    const loadCountries = () => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) {

                    result.sort((a, b) => a.CountryName.localeCompare(b.CountryName));

                    setCountries(result);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    };



    const checkResponseError = (response) => {

        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));

            throw new Error("Network response was not ok");
        }

    }



    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        //changeTab("information");
        changeTab("information");
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);

        loadCountries();
        loadCountryRepresentatives();
        loadCountryDistributors();
        loadImporters();
        loadLegalManufacturers();

        setIsShowingSaveMessage(false);

        setIsEditMode(false);
        setIsAddingProductsToCertificate(false);
        setAddedProductsToCertificate(false);

        resetErrors();


    }



    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if (!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {

        const handleClickOutside = (e) => {

            if (contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target)
            )
                return;

            setIsVersionDropdownOpen(false);
            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    useEffect(() => {

        if (visibleDetailsTab != "information")
            setIsEditMode(false);

    }, [visibleDetailsTab]);





    /*
        When in the view/edit pane, when you click a field this will set edit mode on for that field
    */
    const enableTaskFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };



    /*
        Disable all editable fields in the view/edit form
    */
    const disableAllItemFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };

    
    const onDrop = useCallback((acceptedFiles) => {

        const formData = new FormData();
        acceptedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };


        setIsUploadingFile(true);

        let attachmentUrl = "/Umbraco/Api/Compliance/Upload/?complianceType=" + AppContext.ComplianceType + "&uniqueId=" + AppContext.currentItem.UniqueId;

        fetch(attachmentUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    // Update item
                    AppContext.setCurrentItem({ ...AppContext.currentItem, MedboardResourceId: data });

                    // Update list
                    // Update list
                    AppContext.setData(list =>
                        list.map(item =>
                            item.Id == AppContext.currentItem.Id ? { ...item, MedboardResourceId: data } : item
                        )
                    );
                    
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsUploadingFile(false);
            });

    }, [AppContext.currentItem]);



    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [], // PDF
        },
        multiple: false,
    });




    // Canceling edit changes
    const cancelEdit = () => {

        AppContext.setCurrentItem(AppContext.originalItem);
        setIsEditMode(false);
        setVersion(v => v + 1);

    }


    // Canceling edit mode changes
    const cancelEditNote = () => {

        AppContext.setCurrentItem(prev => ({ ...prev, Note: AppContext.originalItem.Note }));
        setIsEditModeNote(false);
        setVersion(v => v + 1);

    }




    const toggleEditMode = () => {

        setIsEditMode(!isEditMode);

        setIsShowingSaveMessage(false);
    }


    const toggleEditModeNote = () => {

        setIsEditModeNote(!isEditModeNote);

        setIsShowingSaveMessageNotes(false);
    }


    const changeTab = (tab) => {

        setIsShowingSaveMessage(false);

        setIsShowingSaveMessageNotes(false);
        setIsShowingSaveMessageEdit(false);
        setIsShowingSaveMessageAssignPriorityAlerts(false);
        setIsShowingSaveMessageBulkUpdates(false);

        setVisibleDetailsTab(tab);
    }


    const closePane = () => {

        AppContext.closePane();

    }




    

    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (
            typeof a !== "object" || a === null ||
            typeof b !== "object" || b === null
        ) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key)) return false;

            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    };



    // Fill in the state object for the bulk updates
    useEffect(() => {

        if (AppContext.currentItem) {
            setAppContextBulkObject({
                currentItem: AppContext.currentItem,
                setCurrentItem: (newValue) => {
                    setAppContextBulkObject(prev => ({
                        ...prev,
                        currentItem: newValue,
                    }));
                },
            });
        }

    }, [AppContext.currentItem]);



    // Check assigned to if months gets checked

    useEffect(() => {
        if (isBulkUpdateFieldActivatedMonths) {
            setIsBulkUpdateFieldActivatedAssignedTo(true);
        }
    }, [isBulkUpdateFieldActivatedMonths]);


    // Uncheck months if assigned to gets unchecked
    
    useEffect(() => {
        if (!isBulkUpdateFieldActivatedAssignedTo) {
            setIsBulkUpdateFieldActivatedMonths(false);
        }
    }, [isBulkUpdateFieldActivatedAssignedTo]);







    const tabs = [
        { title: "Certificate Details", tab: "information" },
        { title: "Registrations", tab: "registrations" },
        { title: "Files", tab: "documents" },
        { title: "Comments", tab: "comments" },
        { title: "History", tab: "history" },
        { title: "Notes", tab: "notes", onlyAdmin: true },
        //{ title: "Edit", tab: "edit", onlyAdmin: true },
        //{ title: "Assign User, Priority & Alerts", tab: "assign-priority-alerts", onlyAdmin: true },
        //{ title: "Bulk Updates", tab: "bulk-updates", onlyAdmin: true },
        { title: "Tasks", tab: "task-manager" },
        { title: "Submissions", tab: "submissions" },

    ];


    const PriorityList = [
        { Id: -1, Name: "Choose an option" },
        { Id: 0, Name: "None" },
        { Id: 1, Name: "Low" },
        { Id: 2, Name: "Medium" },
        { Id: 3, Name: "High" },

    ];

    const SellingList = [
        { Id: -1, Name: "Choose an option" },
        { Id: "true", Name: "Yes" },
        { Id: "false", Name: "No" },

    ];


    const StatusList = [
        { Id: -1, Name: "Choose an option" },
        { Id: 7, Name: "Pre-Market Assessment" },
        { Id: 0, Name: "New Registration Ongoing" },
        { Id: 6, Name: "Registration Not Required" },
        { Id: 1, Name: "Active" },
        { Id: 3, Name: "Active - Renewing" },
        { Id: 4, Name: "Active - Modification" },
        { Id: 5, Name: "Suspended" },
        { Id: 2, Name: "Expired" },
        { Id: 8, Name: "Discontinued" },
        { Id: 9, Name: "Not Registered" },
    ];


    const usersList = [{ Id: -1, Name: "Choose an option"}, ...AppContext.users ];





    const riskClassList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "I" },
        { Id: 1, Name: "Is" },
        { Id: 2, Name: "Im" },
        { Id: 3, Name: "II" },
        { Id: 4, Name: "IIa" },
        { Id: 5, Name: "IIb" },
        { Id: 6, Name: "III" },
        { Id: 7, Name: "IV" },
        { Id: 8, Name: "A" },
        { Id: 9, Name: "B" },
        { Id: 10, Name: "C" },
        { Id: 11, Name: "D" },
        { Id: 12, Name: "Unclassified" },
        { Id: 13, Name: "Other" },
    ];



    const registrationStatusList = [
        { Id: "", Name: "Choose an option", className: "g-bg-blue" },
        { Id: 7, Name: "Pre-Market Assessment", className: "g-bg-blue" },
        { Id: 0, Name: "New Registration Ongoing", className: "g-bg-blue" },
        { Id: 6, Name: "Registration Not Required", className: "g-bg-gray-light-v1" },
        { Id: 1, Name: "Active", className: "g-bg-green" },
        { Id: 3, Name: "Active - Renewing", className: "g-bg-green" },
        { Id: 4, Name: "Active - Modification", className: "g-bg-green" },
        { Id: 5, Name: "Suspended", className: "g-bg-lightred" },
        { Id: 2, Name: "Expired", className: "g-bg-lightred" },
        { Id: 8, Name: "Discontinued", className: "g-bg-black" },
        { Id: 9, Name: "Not Registered", className: "g-bg-orange" },
    ];



    const yesNoList = [
        { Id: "", Name: "Choose an option" },
        { Id: "true", Name: "Yes" },
        { Id: "false", Name: "No" },
    ];


    const renewalPriorityList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "None" },
        { Id: 1, Name: "Low" },
        { Id: 2, Name: "Medium" },
        { Id: 3, Name: "High" },
    ];


    const displayFieldOnly = true;

    let fullWidthPane = true;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto", backgroundColor: "#f7fafc" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">

                        
                        <p style={{ color: "#555", fontSize: "11px" }}>
                            <span className="breadcrumb-link" style={{ marginRight: "5px" }} onClick={() => closePane()}>Certificates</span>
                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? null :
                                <>
                                    &gt; <span style={{ marginLeft: "5px" }}> {AppContext.currentItem.Name}</span>
                                </>
                            }
                        </p>


                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}


                        <div className="item-details-content">

                            <div className="item-details-content-tabs">

                                <div className="nav" style={{ display: "flex", flexDirection: "column", gap: "4px" }} >

                                    {tabs.map((tab, index) => {
                                        if (tab.onlyAdmin && AppContext.userRole !== "Admin") {
                                            return null;
                                        }

                                        return (
                                            <a
                                                key={index} // better than index if tab.tab is unique
                                                onClick={() => changeTab(tab.tab)}
                                                className={`nav-item item-details-menu-tab ${visibleDetailsTab === tab.tab ? "active" : ""
                                                    }`}
                                            >
                                                {tab.title}
                                            </a>
                                        );
                                    })}

                                </div>

                            </div>


                            <div className="item-details-content-content">

                                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                    <>
                                        <LayoutComponents.PageLoading />
                                    </>
                                ) : (
                                    <>

                                        {/* Header */}

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 700, color: "#1a202c", display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <i className="fas fa-clipboard" style={{ color: "#2b6cb0" }} />
                                                    Certificate
                                                </h2>

                                                <span style={{ fontSize: "16px", color: "#4a5568", fontWeight: 600, background: "#edf2f7", padding: "4px 12px", borderRadius: "6px" }}>
                                                    {AppContext.currentItem?.Name}
                                                </span>
                                            </div>

                                            <div style={{ display: "flex", gap: "8px" }}>

                                                    {visibleDetailsTab == "information" ? <>

                                                        {AppContext.userRole == "Admin" ? <>

                                                        {isEditMode ?

                                                            <div id="buttom-bar" >

                                                                {/* FORMS BUTTONS */}

                                                                <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                    <div className="action-button-bar-left"></div>
                                                                    <div className="action-button-bar-center"></div>

                                                                    <div className="action-button-bar-right">

                                                                        {!isSavingItem ? (
                                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                                <button
                                                                                    className="action-button save-button"
                                                                                    onClick={() => cancelEdit()}
                                                                                    onMouseOver={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                        e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                    }}
                                                                                    onMouseOut={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                                                    }}
                                                                                    style={{
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        padding: "6px 14px",
                                                                                        cursor: "pointer",
                                                                                        transition: "all 0.2s ease-in-out",
                                                                                        color: "#5f6368",
                                                                                        border: "1px solid #dee2e6",
                                                                                        backgroundColor: "#ffffff",
                                                                                        whiteSpace: "nowrap",
                                                                                        outline: "none"
                                                                                    }}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                                <button
                                                                                    className="action-button save-button"
                                                                                    onClick={() => setIsShowingConfirmSavePopup(true)}
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                <LoadingSpinnerImage />
                                                                            </>
                                                                        )}


                                                                    </div>


                                                                </div>

                                                            </div>

                                                            :
                                                            <>
                                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                    <div style={{
                                                                        flex: 1,
                                                                        justifyContent: "right",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        marginRight: "20px",
                                                                    }}>
                                                                        {isShowingSaveMessage ?
                                                                            <span className="save-message-shown">
                                                                                Save successful!
                                                                            </span>
                                                                            : null}
                                                                    </div>

                                                                    

                                                                    <div>
                                                                        <div className="view-task-field" style={{
                                                                            textAlign: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginBottom: "0px",
                                                                        }}>
                                                                            <span onClick={() => toggleEditMode()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                                <i className="far fa-edit pointer g-mr-8"></i>Edit Certificate
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                            </>
                                                        }

                                                    </>

                                                        : null}

                                                    </> : null}



                                                    

                                                    {visibleDetailsTab == "notes" ? <>

                                                        {AppContext.userRole == "Admin" ? <>

                                                            {isEditModeNote ?


                                                                <div id="buttom-bar" >

                                                                    {/* FORMS BUTTONS */}

                                                                    <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                        <div className="action-button-bar-left"></div>
                                                                        <div className="action-button-bar-center"></div>

                                                                        <div className="action-button-bar-right">

                                                                            <div style={{display: "flex", flexDirection: "row"}}>

                                                                                {!isSavingItemNotes ? (
                                                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                                        <button
                                                                                            className="action-button save-button"
                                                                                            onClick={() => cancelEditNote()}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                                e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                                e.currentTarget.style.borderColor = "#dee2e6";
                                                                                            }}
                                                                                            style={{
                                                                                                display: "inline-flex",
                                                                                                alignItems: "center",
                                                                                                padding: "6px 14px",
                                                                                                cursor: "pointer",
                                                                                                transition: "all 0.2s ease-in-out",
                                                                                                color: "#5f6368",
                                                                                                border: "1px solid #dee2e6",
                                                                                                backgroundColor: "#ffffff",
                                                                                                whiteSpace: "nowrap",
                                                                                                outline: "none"
                                                                                            }}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                        <button
                                                                                            className="action-button save-button"
                                                                                            onClick={() => saveCurrentItemPartial("notes")}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#1a73e8";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#1a73e8";
                                                                                            }}
                                                                                            style={{
                                                                                                display: "inline-flex",
                                                                                                alignItems: "center",
                                                                                                padding: "6px 14px",
                                                                                                cursor: "pointer",
                                                                                                transition: "all 0.2s ease-in-out",
                                                                                                color: "#ffffff",
                                                                                                border: "1px solid #1a73e8",
                                                                                                backgroundColor: "#1a73e8",
                                                                                                whiteSpace: "nowrap",
                                                                                                outline: "none"
                                                                                            }}
                                                                                        >
                                                                                            Save
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        <LoadingSpinnerImage />
                                                                                    </>
                                                                                )}


                                                                            </div>


                                                                        </div>


                                                                    </div>

                                                                </div>



                                                                :
                                                                <>
                                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                                        <div style={{
                                                                            flex: 1,
                                                                            justifyContent: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginRight: "20px",
                                                                        }}>
                                                                            {isShowingSaveMessageNotes ?
                                                                                <span className="save-message-shown">
                                                                                    Save successful!
                                                                                </span>
                                                                                : null}
                                                                        </div>



                                                                        <div>
                                                                            <div className="view-task-field" style={{
                                                                                textAlign: "right",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginBottom: "0px",
                                                                            }}>
                                                                                <span onClick={() => toggleEditModeNote()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                                    <i className="fas fa-edit g-pr-8"></i>Edit Notes
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                </>
                                                            }

                                                        </> : null}

                                                    </> : null}







                                                    <button ref={contextMenuButton} onClick={openContextualMenu} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-ellipsis-v" />
                                                </button>

                                                <button onClick={() => closePane()} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </div>


                                        {/* Main content */}

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>


                                            {/* INFORMATION DASHBOARD */}

                                            {visibleDetailsTab == "information" ?

                                                <>

                                                    {/* LEFT */}

                                                    <div style={{ flex: 2, minWidth: "400px", display: "flex", flexDirection: "column", gap: "24px" }}>
                                                        <LayoutComponents.InfoBlock>
                                                            <div style={{ display: "flex", gap: "40px" }}>

                                                                <div>
                                                                    <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                        Country / Jurisdiction
                                                                    </span>

                                                                    <span style={{ fontSize: "16px", fontWeight: 600, color: "#2d3748", display: "flex", alignItems: "center", gap: "6px" }}>

                                                                            {/* {isEditMode ? <>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"CountryId"} fieldName={"CountryName"} fieldTitle={"Country"} LOV={countries} LOVIdField={"CountryId"} LOVNameField={"CountryName"} mandatory={false} enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                        </> : <>*/}
                                                                            {AppContext.currentItem?.CountryName ?
                                                                                <a target="_blank" href={`/your-medboard/country-registrations/registrations/?filter[CountryId]=${AppContext.currentItem?.CountryId}`}>
                                                                                    <img
                                                                                        className="countryFlag"
                                                                                        src={AppContext.currentItem?.FlagLink}
                                                                                        style={{ height: "20px", marginRight: "5px" }}
                                                                                        alt=""
                                                                                    />
                                                                                    {AppContext.currentItem?.CountryName}
                                                                                </a>
                                                                                : "---"}

                                                                    </span>
                                                                </div>

                                                                <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                    <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                        Registry Reference
                                                                    </span>

                                                                    <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>

                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Name"} fieldTitle={"Name"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                            
                                                                    </span>
                                                                </div>

                                                                <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                    <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                        Legal Manufacturer
                                                                    </span>

                                                                    {isEditMode ? (
                                                                        <FieldTypes.ItemDetailsField_MultiSelect
                                                                            key={`lm_${version}_edit`}
                                                                            AppContext={AppContext}
                                                                            fieldTitle={"Legal Manufacturer(s)"}
                                                                            fieldName={"LegalManufacturerIds"}
                                                                            selectedItems={AppContext.currentItem.LegalManufacturerIds ?? []}
                                                                            LOV={legalManufacturers}
                                                                            LOVIdField={"EstablishmentId"}
                                                                            LOVNameField={"Establishment"}
                                                                            noneIsAll={false}
                                                                            forceIsEditing={true}
                                                                            displayFieldOnly={displayFieldOnly}
                                                                            itemLink={"/your-medboard/country-registrations/certificates/view-operator/[PARAM]/"}
                                                                        />
                                                                    ) : (
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            {(AppContext.currentItem.LegalManufacturers ?? []).length > 0 ? (
                                                                                <FieldTypes.FieldType_ProductLegalManufacturers value={AppContext.currentItem.LegalManufacturers} />
                                                                            ) : (
                                                                                "---"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                </div>

                                                            </div>
                                                        </LayoutComponents.InfoBlock>


                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                Authorized Supply Chain / Operators
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                                                                {/* Entry Node: Distributor */}
                                                                <div style={{ paddingLeft: "14px", borderLeft: "4px solid #3398dc" }}>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                        Country Distributor
                                                                    </label>

                                                                    <FieldTypes.ItemDetailsField_MultiSelect key={`dist_${version}`} AppContext={AppContext} fieldTitle={"Country Distributor(s)"} fieldName={"CountryDistributorsIds"} selectedItems={AppContext.currentItem.CountryDistributorsIds ?? []} LOV={countryDistributors} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={4} onRefreshOperators={loadCountryDistributors} />

                                                                </div>

                                                                {/* Entry Node: Representative */}
                                                                <div style={{ paddingLeft: "14px", borderLeft: "4px solid #2a6e92" }}>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                        Country Representative
                                                                    </label>
                                                                    <FieldTypes.ItemDetailsField_MultiSelect key={`rep_${version}`} AppContext={AppContext} fieldTitle={"Country Representative"} fieldName={"CountryRepresentativesIds"} selectedItems={AppContext.currentItem.CountryRepresentativesIds ?? []} LOV={countryRepresentatives} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={3} onRefreshOperators={loadCountryRepresentatives} />
                                                                </div>

                                                                {/* Entry Node: Importer */}
                                                                <div style={{ paddingLeft: "14px", borderLeft: "4px solid #203864" }}>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                        Importer
                                                                    </label>
                                                                    <FieldTypes.ItemDetailsField_MultiSelect key={`imp_${version}`} AppContext={AppContext} fieldTitle={"Importer(s)"} fieldName={"ImportersIds"} selectedItems={AppContext.currentItem.ImportersIds ?? []} LOV={importers} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={2} onRefreshOperators={loadImporters} />
                                                                </div>  

                                                            </div>

                                                        </LayoutComponents.InfoBlock>

                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                Analytics
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap" }}>

                                                                    <div style={{ flex: 1, }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Registrations
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.RegistrationCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("registrations")}>{AppContext.currentItem?.RegistrationCount ?? 0}</span>
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Documents
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.DocumentCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("documents")}>{AppContext.currentItem?.DocumentCount ?? 0}</span>
                                                                        </span>
                                                                    </div>
                                                                   
                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Open Tasks
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.TaskCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("task-manager")}>{AppContext.currentItem?.TaskCount ?? 0}</span>
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Comments
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.CommentCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("comments")}>{AppContext.currentItem?.CommentCount ?? 0}</span>
                                                                        </span>
                                                                    </div>
                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Open Submissions
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.SubmissionCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("submissions")}>{AppContext.currentItem?.SubmissionCount ?? 0}</span>
                                                                        </span>
                                                                    </div>
                                                                

                                                            </div>

                                                        </LayoutComponents.InfoBlock>

                                                    </div>

                                                    {/* RIGHT */}

                                                    <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "24px" }}>

                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                Registration Status
                                                            </h4>
                                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                        Lifecycle Status
                                                                        </label>

                                                                        {isEditMode ? <>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"Status"} fieldName={"_Status"} fieldTitle={"Status"} LOV={StatusList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </> : <>
                                                                            {AppContext.currentItem?.Status ?
                                                                                <FieldTypes.FieldType_RegistrationsStatus value={AppContext.currentItem.Status} /> : "---"}
                                                                        </>}

                                                                </div>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                        Selling
                                                                    </label>

                                                                        {isEditMode ? <>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"Selling"} fieldName={"_Selling"} fieldTitle={"Selling"} LOV={SellingList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </> : <>
                                                                            {AppContext.currentItem?.Selling !== null ?
                                                                                <FieldTypes.FieldType_CountryRegistrationSelling value={AppContext.currentItem.Selling} /> : "---"}
                                                                        </>}

                                                                </div>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                        Expiry date
                                                                    </label>

                                                                    {isEditMode ? <>
                                                                        <FieldTypes.ItemDetailsField_DateUTC AppContext={AppContext} field={"ExpiryDate"} fieldTitle={"Expiry Date"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </> : <>
                                                                        {AppContext.currentItem?.ExpiryDate ?
                                                                            <FieldTypes.FieldType_DateWithExpiredWarningUTC value={AppContext.currentItem.ExpiryDate} /> : "---"}
                                                                    </>}

                                                                </div>

                                                            </div>


                                                        </LayoutComponents.InfoBlock>

                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                Assignments & Alerts
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "6px" }}>
                                                                            Assigned to 
                                                                    </label>

                                                                        {isEditMode ? <>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"AssignedTo"} fieldName={"_AssignedTo"} fieldTitle={"Assigned User"} LOV={usersList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </> : <>
                                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                                {AppContext.currentItem?.AssignedTo ?
                                                                                    AppContext.currentItem.AssignedTo?.map(user =>
                                                                                        <FieldTypes.FieldType_FullUser
                                                                                            users={AppContext.users}
                                                                                            value={user}
                                                                                        />
                                                                                    ) : "---"}
                                                                            </div>
                                                                        </>}


                                                                </div>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                        Priority
                                                                    </label>

                                                                        {isEditMode ? <>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"Priority"} fieldName={"_Priority"} fieldTitle={"Renewal Priority"} LOV={PriorityList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </> : <>
                                                                            {AppContext.currentItem?.Priority !== null ?
                                                                            <FieldTypes.FieldType_RegistrationPriority value={AppContext.currentItem.Priority} />
                                                                                : "---"}
                                                                        </>}

                                                                </div>

                                                                <div>
                                                                    {/* Existing Label */}
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                        Alert Time (Months before expiration)
                                                                    </label>

                                                                    {isEditMode ? <>
                                                                        <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Months"} fieldTitle={"Alert Time in Months"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </> : <>
                                                                        {/* Value and Notification Calculation */}
                                                                        {AppContext.currentItem?.Months ? (
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                              
                                                                                <span className="fas fa-bell"></span>

                                                                                {/* 2. Display the Months */}
                                                                                <span>{AppContext.currentItem.Months} Month(s)</span>

                                                                                {/* 3. Display Calculated Notification Date */}
                                                                                {AppContext.currentItem.ExpiryDate && (
                                                                                    <span style={{ fontSize: "12px", color: "#718096" }}>
                                                                                        (Alert Date: {
                                                                                            (() => {
                                                                                                const expiry = new Date(AppContext.currentItem.ExpiryDate);

                                                                                                // Subtract months in UTC
                                                                                                expiry.setUTCMonth(expiry.getUTCMonth() - AppContext.currentItem.Months);

                                                                                                const monthNames = [
                                                                                                    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                                                                                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                                                                                                ];

                                                                                                const day = String(expiry.getUTCDate()).padStart(2, "0");
                                                                                                const month = monthNames[expiry.getUTCMonth()];
                                                                                                const year = expiry.getUTCFullYear();

                                                                                                return `${day} ${month}, ${year}`;
                                                                                            })()
                                                                                        })
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            "---"
                                                                        )}
                                                                    </>}


                                                                </div>

                                                            </div>
                                                        </LayoutComponents.InfoBlock>

                                                    </div>

                                                </>

                                                : null}






                                                {/* REGISTRATIONS */}

                                                {visibleDetailsTab == "registrations" &&
                                                    <div style={{ height: "100%", overflow: "auto", width: "100%" }}>
                                                        <div style={{ marginBottom: "20px" }}>
                                                            <RegistrationsList
                                                                AppContext={AppContext}
                                                                refresh={registrationListRefresh}
                                                                customButtons={
                                                                    AppContext.userRole === "Admin"
                                                                        ? [
                                                                            { Name: "Bulk Updates", callback: openBulkUpdatesPopup, cssIcon: "fas fa-pen-square", requiresSelection: true, buttonBackground: "#8a9de6", buttonFontColor: "#f7f7f7" },
                                                                            { Name: "Add products to certificate", callback: openAddProductsToCertificatePopup, cssIcon: "fas fa-plus-circle", buttonBackground: "#3398dc", buttonFontColor: "#f7f7f7" },
                                                                        ]
                                                                        : []
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                }





                                            {/* DOCUMENTS */}

                                            {visibleDetailsTab == "documents" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%" }}>

                                                    <div style={{ marginBottom: "20px" }}>
                                                            <DocumentsList AppContext={AppContext} refresh={documentListRefresh} setRefresh={setDocumentListRefresh}
                                                                customButtons={
                                                                    AppContext.userRole === "Admin"
                                                                    ? [{ Name: "Add file", callback: openDocumentPopup, cssIcon: "fas fa-plus-circle" }]
                                                                    : []
                                                                    } />
                                                    </div>

                                                </div>

                                            }




                                            {/* COMMENTS */}

                                            {visibleDetailsTab == "comments" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>

                                                    <div style={{ marginBottom: "20px" }}>
                                                        <CommentsPanel AppContext={AppContext} certificateId={AppContext.currentItem.Id} />
                                                    </div>

                                                </div>

                                            }





                                            {/* HISTORY */}

                                            {visibleDetailsTab == "history" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>

                                                    <div style={{ marginBottom: "20px" }}>
                                                        <CertificateHistory certificateId={AppContext.currentItem.Id} users={AppContext.users} />
                                                    </div>

                                                </div>

                                            }





                                            {/* TASKS */}

                                            {visibleDetailsTab == "task-manager" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", backgroundColor: "white", padding: "5px", borderRadius: "15px" }}>
                                                    <TaskManager
                                                        emitter={new EventEmitter()}
                                                        paramEntityType="countryregistration-certificate"
                                                        paramEntityId={AppContext.currentItem.Id}
                                                        paramCompanyId={AppContext.currentCompanyId}
                                                        paramUserId={AppContext.currentUserId}
                                                        paramIsSlimVersion={true}
                                                        paramExternalLinkedObjects={[{ EntityType: "countryregistration-certificate", EntityId: AppContext.currentItem.Id }]}
                                                        paramHasLimitedWidth={true} />
                                                </div>
                                            }







                                            

                                            {/* Notes  */}

                                            {visibleDetailsTab == "notes" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>


                                                        <div style={{display: "flex", flexDirection: "row"}}>
                                                            
                                                            <div style={{ width: "100%" }}>

                                                                <LayoutComponents.InfoBlock>

                                                                {isEditModeNote ? <>
                                                                    <FieldTypes.ItemDetailsField_Text key={version} AppContext={AppContext} field={"Note"} fieldTitle={"Notes"} mandatory={false} richText={true} forceIsEditing={isEditModeNote} displayFieldOnly={displayFieldOnly} />

                                                                </> : <>

                                                                    <div dangerouslySetInnerHTML={{ __html: AppContext.currentItem?.Note }} />

                                                                    </>}

                                                                </LayoutComponents.InfoBlock>
                                                            </div>
                                                        </div>


                                                </div>
                                            </>}








                                            {/* EDIT */}

                                            {visibleDetailsTab == "edit" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", minHeight: "500px"  }}>


                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Name"} fieldTitle={"Name"} mandatory={false} forceIsEditing={true} />

                                                    <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"CountryId"} fieldName={"CountryName"} fieldTitle={"Country"} LOV={countries} LOVIdField={"CountryId"} LOVNameField={"CountryName"} mandatory={false} enableSearch={true} forceIsEditing={true} />



                                                    {/* CERTIFICATE SAVE BUTTON */}
                                                    {/* CERTIFICATE SAVE BUTTON */}
                                                    {/* CERTIFICATE SAVE BUTTON */}


                                                    {AppContext.userRole == "Admin" ? <>


                                                        <div id="buttom-bar" >

                                                            {/* FORMS BUTTONS */}

                                                            <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                <div className="action-button-bar-left"></div>
                                                                <div className="action-button-bar-center"></div>

                                                                <div className="action-button-bar-right">

                                                                    {!isSavingItemEdit ? (
                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>

                                                                            <button
                                                                                className="action-button save-button"
                                                                                onClick={() => saveCurrentItemPartial("edit")}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.backgroundColor = "#1a73e8";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.backgroundColor = "#1a73e8";
                                                                                }}
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    padding: "6px 14px",
                                                                                    cursor: "pointer",
                                                                                    transition: "all 0.2s ease-in-out",
                                                                                    color: "#ffffff",
                                                                                    border: "1px solid #1a73e8",
                                                                                    backgroundColor: "#1a73e8",
                                                                                    whiteSpace: "nowrap",
                                                                                    outline: "none"
                                                                                }}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <LoadingSpinnerImage />
                                                                        </>
                                                                    )}

                                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                                        <div style={{
                                                                            flex: 1,
                                                                            justifyContent: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginTop: "10px",
                                                                        }}>
                                                                            {isShowingSaveMessageEdit ?
                                                                                <span className="save-message-shown">
                                                                                    Save successful!
                                                                                </span>
                                                                                : null}
                                                                        </div>



                                                                    </div>

                                                                </div>


                                                            </div>

                                                        </div>


                                                    </>

                                                        : null}




                                                </div>
                                            </>}









                                            {/* SUBMISSIONS */}

                                            {visibleDetailsTab == "submissions" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", backgroundColor: "white", padding: "5px", borderRadius: "15px" }}>
                                                    <Submissions certificateId={AppContext.currentItem.Id} />
                                                </div>
                                            }






                                        </div>


                                    </>
                                )}



                            </div>

                        </div>





                    </div>
                </div>

                : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}


                </div>
            )}

            {/* ADD PRODUCTS TO CERTIFICATE POPUP */}
            {/* ADD PRODUCTS TO CERTIFICATE POPUP */}
            {/* ADD PRODUCTS TO CERTIFICATE POPUP */}

            {isShowingAddProductsToCertificatePopup ?

                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        justifyContent: "center",
                        zIndex: 1000,
                        overflowY: "auto",
                        alignItems: "flex-start"
                    }}
                >
                    <div
                        id="add-products-popup"
                        style={{
                            width: "50%",
                            zIndex: 1000,
                            border: "1px solid rgb(51, 51, 51)",
                            padding: "15px",
                            backgroundColor: "rgb(250, 250, 250)",
                            borderRadius: "10px",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                            margin: "120px auto 40px auto",
                        }}
                    >
                    <div style={{ display: "flex", marginBottom: "5px" }}>
                        <div style={{ width: "50%" }}>
                            <h3>Add Products to certificate</h3>
                        </div>

                        <div style={{ width: "50%", textAlign: "right" }}>
                            <button
                                onClick={() => setIsShowingAddProductsToCertificatePopup(false)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                }}
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    <div style={{ height: "100%", overflow: "auto", }}>

                        <div style={{ display: "flex", flexDirection: "row" }}>

                            <div style={{ width: "50%" }} >



                                <>
                                    <div style={{ width: "100%" }}>
                                        Registration issued by (Organization)
                                        <br />
                                        <input className={`form-field-text add-task-field-name ${errorAddIssued ? " form-field-error" : null}`}
                                            value={addIssued}
                                            onChange={(e) => setAddIssued(e.target.value)}
                                            style={{ width: "100%" }} type="text" placeholder="" />

                                        {errorAddIssued && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}

                                    </div>

                                    <br />



                                    {/* Importers */}


                                    <div style={{ width: "100%" }}>

                                        <MultiSelectField
                                        field={field_IMPORTERS}
                                        formState={formState_IMPORTERS}
                                        setFormState={setFormState_IMPORTERS}
                                        fieldsConfig={fieldConfig_IMPORTERS}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={2}
                                        onRefreshOperators={() => loadOperators(true)}
                                        />

                                    </div>

                                    <br />



                                    {/* Representative */}

                                    <div style={{ width: "100%" }}>

                                        <MultiSelectField
                                        field={field_REPRESENTATIVES}
                                        formState={formState_REPRESENTATIVES}
                                        setFormState={setFormState_REPRESENTATIVES}
                                        fieldsConfig={fieldConfig_REPRESENTATIVES}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={3}
                                        onRefreshOperators={() => loadOperators(true)}
                                        />

                                    </div>

                                    <br />




                                    {/* Distributors */}

                                    <div style={{ width: "100%" }}>

                                        <MultiSelectField
                                        field={field_DISTRIBUTORS}
                                        formState={formState_DISTRIBUTORS}
                                        setFormState={setFormState_DISTRIBUTORS}
                                        fieldsConfig={fieldConfig_DISTRIBUTORS}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={4}
                                        onRefreshOperators={() => loadOperators(true)}
                                        />

                                    </div>

                                    <br />




                                    <div style={{ width: "100%" }}>
                                        Risk Class *
                                        <br />

                                        <select
                                            className={`form-field-text add-task-field-name ${errorAddRiskClass ? "form-field-error" : ""
                                                }`}
                                            value={addRiskClass}
                                            onChange={(e) => setAddRiskClass(e.target.value)}
                                            style={{ width: "100%" }}
                                        >
                                            {riskClassList.map((item) => (
                                                <option key={item.Id} value={item.Id}>
                                                    {item.Name}
                                                </option>
                                            ))}
                                        </select>

                                        {errorAddRiskClass && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}
                                    </div>

                                    <br />



                                    <div style={{ width: "100%" }}>
                                        Registration Status *
                                        <br />

                                        <select
                                            className={`form-field-text add-task-field-name ${errorAddRegistrationStatus ? "form-field-error" : ""
                                                }`}
                                            value={addRegistrationStatus}
                                            onChange={(e) => setAddRegistrationStatus(e.target.value)}
                                            style={{ width: "100%" }}
                                        >

                                            {registrationStatusList.map((item) => (
                                                <option key={item.Id} value={item.Id}>
                                                    {item.Name}
                                                </option>
                                            ))}
                                        </select>

                                        {errorAddRegistrationStatus && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}
                                    </div>

                                    <br />




                                    <div style={{ width: "100%" }}>
                                        Selling *
                                        <br />

                                        <select
                                            className={`form-field-text add-task-field-name ${errorAddSelling ? "form-field-error" : ""
                                                }`}
                                            value={addSelling}
                                            onChange={(e) => setAddSelling(e.target.value.toString())}
                                            style={{ width: "100%" }}
                                        >

                                            {yesNoList.map((item) => (
                                                <option key={item.Id.toString()} value={item.Id.toString()}>
                                                    {item.Name}
                                                </option>
                                            ))}
                                        </select>

                                        {errorAddSelling && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}
                                    </div>

                                    <br />


                                    <div style={{ width: "100%" }}>
                                        Assigned User
                                        <br />

                                        <select
                                            className={`form-field-text add-task-field-name ${errorAddAssigned ? "form-field-error" : ""
                                                }`}
                                            value={addAssigned}
                                            onChange={(e) => setAddAssigned(e.target.value)}
                                            style={{ width: "100%" }}
                                        >
                                            <option value="">Select User</option>

                                            {AppContext.users.map((user) => (
                                                <option key={user.Id} value={user.Id}>
                                                    {user.Name}
                                                </option>
                                            ))}
                                        </select>

                                        {errorAddAssigned && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}
                                    </div>

                                    <br />





                                    <div style={{ width: "100%" }}>
                                        Renewal Priority *
                                        <br />

                                        <select
                                            className={`form-field-text add-task-field-name ${errorAddPriority ? "form-field-error" : ""
                                                }`}
                                            value={addPriority}
                                            onChange={(e) => setAddPriority(e.target.value)}
                                            style={{ width: "100%" }}
                                        >

                                            {renewalPriorityList.map((item) => (
                                                <option key={item.Id} value={item.Id}>
                                                    {item.Name}
                                                </option>
                                            ))}
                                        </select>

                                        {errorAddPriority && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}
                                    </div>

                                    <br />

                                    <div style={{ width: "100%" }}>
                                        Expiry Date
                                        <br />

                                        <input
                                            className={`form-field-text add-task-field-name ${errorAddExpiryDate ? "form-field-error" : ""
                                                }`}
                                            value={addExpiryDate}
                                            onChange={(e) => setAddExpiryDate(e.target.value)}
                                            style={{ width: "100%" }}
                                            type="date"
                                        />

                                        {errorAddExpiryDate && (
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        )}
                                    </div>

                                    <br />

                                </>

                            </div>
                        
                            <div style={{ paddingLeft: "25px" }}>
                                <ProductTreeSelector
                                    onSelectionChange={setAddProductIds}
                                    legalManufacturerIds={AppContext.currentItem?.LegalManufacturerIds ?? []}
                                    legalManufacturerNames={
                                        (AppContext.currentItem?.LegalManufacturerIds ?? [])
                                            .map(id =>
                                                legalManufacturers.find(lm => lm.EstablishmentId == id)?.Establishment
                                                || (AppContext.currentItem?.LegalManufacturers ?? []).find(lm => lm.OperatorId == id)?.OperatorName
                                            )
                                            .filter(Boolean)
                                    }
                                />

                                {errorNoProducts ?
                                    <div style={{ color: "#ff5400" }}>No products have been selected</div>
                                    : null}

                               
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "26px" }}>




                            {addedProductsToCertificate ?
                                <span className="save-message-shown">Successfully added products to certificate</span>
                                : null}

                            {errorAddingItem ?
                                <div style={{ color: "#ff5400" }}>{errorAddingItem}</div>
                                : null}




                            {isAddingProductsToCertificate ? <div><LoadingSpinnerImage /></div> :

                                <button
                                    className="action-button save-button"
                                    onClick={() => addProductsToCertificate()}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = "#1a73e8";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor = "#1a73e8";
                                    }}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease-in-out",
                                        color: "#ffffff",
                                        border: "1px solid #1a73e8",
                                        backgroundColor: "#1a73e8",
                                        whiteSpace: "nowrap",
                                        outline: "none"
                                    }}
                                >
                                    Add Products
                                </button>
                            }
                        </div>
                    </div>

                </div>

                </div>
                : null}









            {/* Registrations Bulk Updates Popup */}

            {isShowingBulkUpdatesPopup && visibleDetailsTab === "registrations" ? (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Slightly darker for better focus
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center", // Centered vertically
                        zIndex: 1000,
                        padding: "20px"
                    }}
                >
                    <div
                        id="add-products-popup"
                        style={{
                            width: "100%",
                            maxWidth: "750px", // Better than fixed 50%
                            maxHeight: "90vh", // Prevents it from going off-screen
                            display: "flex",
                            flexDirection: "column",
                            zIndex: 1000,
                            border: "1px solid #d1d5db",
                            backgroundColor: "#ffffff", // Clean white background
                            borderRadius: "10px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                        }}
                    >
                        {/* --- HEADER --- */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "20px 24px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, color: "#1f2937", fontSize: "20px" }}>
                                Bulk update:  {registrationsIdsSelected?.length || 0} registration{registrationsIdsSelected?.length !== 1 ? 's' : ''}
                            </h3>
                            <button
                                onClick={() => setIsShowingBulkUpdatesPopup(false)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    color: "#6b7280",
                                    padding: "4px"
                                }}
                                title="Close"
                            >
                                ✕
                            </button>
                        </div>

                        {/* --- SCROLLABLE CONTENT --- */}
                        <div style={{
                            overflowY: "auto",
                            padding: "24px",
                            flex: 1
                        }}>

                            {/* STATUS */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedStatus}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedStatus(e.target.checked)}
                                        />
                                        Status
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedStatus && (
                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={appContextBulkObject} fieldId={"Status"} fieldName={"_Status"} fieldTitle={"Status"} LOV={StatusList.filter(s => s.Id !== -1)} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* RISK CLASS */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedRiskClass}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedRiskClass(e.target.checked)}
                                        />
                                        Risk Class
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedRiskClass && (
                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={appContextBulkObject} fieldId={"RiskClass"} fieldName={"_RiskClass"} fieldTitle={"Risk Class"} LOV={riskClassList.filter(s => s.Id !== "")} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* EXPIRY DATE */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedExpiryDate}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedExpiryDate(e.target.checked)}
                                        />
                                        Expiry Date
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedExpiryDate && (
                                        <FieldTypes.ItemDetailsField_Date AppContext={appContextBulkObject} field={"ExpiryDate"} fieldTitle={"Expiry Date"} mandatory={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* SELLING */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedSelling}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedSelling(e.target.checked)}
                                        />
                                        Selling
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedSelling && (
                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={appContextBulkObject} fieldId={"Selling"} fieldName={"_Selling"} fieldTitle={"Selling"} LOV={SellingList.filter(s => s.Id !== -1)} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* ASSIGNED TO */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedAssignedTo}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedAssignedTo(e.target.checked)}
                                        />
                                        Assigned To
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedAssignedTo && (
                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={appContextBulkObject} fieldId={"AssignedTo"} fieldName={"_AssignedTo"} fieldTitle={"Assigned User"} LOV={usersList.filter(u => u.Id !== -1)} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={true} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* ALERT TIME */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedMonths}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedMonths(e.target.checked)}
                                        />
                                        Alert time (Months)
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedMonths && (
                                        <FieldTypes.ItemDetailsField_Text AppContext={appContextBulkObject} field={"Months"} fieldTitle={"Alert Time in Months"} mandatory={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* PRIORITY */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedPriority}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedPriority(e.target.checked)}
                                        />
                                        Priority
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedPriority && (
                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={appContextBulkObject} fieldId={"Priority"} fieldName={"_Priority"} fieldTitle={"Renewal Priority"} LOV={PriorityList.filter(s => s.Id !== -1)} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* ISSUED BY */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedIssuedBy}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedIssuedBy(e.target.checked)}
                                        />
                                        Issued By
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedIssuedBy && (
                                        <FieldTypes.ItemDetailsField_Text AppContext={appContextBulkObject} field={"IssuedBy"} fieldTitle={"Issued By"} mandatory={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} />
                                    )}
                                </div>
                            </div>

                            {/* DISTRIBUTORS */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedDistributors}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedDistributors(e.target.checked)}
                                        />
                                        Distributors
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedDistributors && (
                                        <div style={{ paddingLeft: "14px", borderLeft: "4px solid #3398dc" }}>
                                            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                Country Distributor
                                            </label>
                                            <FieldTypes.ItemDetailsField_MultiSelect key={`dist_${version}`} AppContext={appContextBulkObject} fieldTitle={"Country Distributor(s)"} fieldName={"CountryDistributorsIds"} selectedItems={appContextBulkObject.currentItem.CountryDistributorsIds ?? []} LOV={countryDistributors} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={4} onRefreshOperators={loadCountryDistributors} />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* REPRESENTATIVES */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedRepresentatives}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedRepresentatives(e.target.checked)}
                                        />
                                        Representatives
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedRepresentatives && (
                                        <div style={{ paddingLeft: "14px", borderLeft: "4px solid #2a6e92" }}>
                                            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                Country Representative
                                            </label>
                                            <FieldTypes.ItemDetailsField_MultiSelect key={`rep_${version}`} AppContext={appContextBulkObject} fieldTitle={"Country Representative"} fieldName={"CountryRepresentativesIds"} selectedItems={appContextBulkObject.currentItem.CountryRepresentativesIds ?? []} LOV={countryRepresentatives} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={3} onRefreshOperators={loadCountryRepresentatives} />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* IMPORTERS */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", minHeight: "40px" }}>
                                <div style={{ width: "220px", flexShrink: 0 }}>
                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontWeight: 500 }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: "12px", cursor: "pointer" }}
                                            checked={isBulkUpdateFieldActivatedImporters}
                                            onChange={(e) => setIsBulkUpdateFieldActivatedImporters(e.target.checked)}
                                        />
                                        Importers
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isBulkUpdateFieldActivatedImporters && (
                                        <div style={{ paddingLeft: "14px", borderLeft: "4px solid #203864" }}>
                                            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                Importer
                                            </label>
                                            <FieldTypes.ItemDetailsField_MultiSelect key={`imp_${version}`} AppContext={appContextBulkObject} fieldTitle={"Importer(s)"} fieldName={"ImportersIds"} selectedItems={appContextBulkObject.currentItem.ImportersIds ?? []} LOV={importers} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={true} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={2} onRefreshOperators={loadImporters} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* --- FOOTER / SAVE BUTTON --- */}
                        {AppContext.userRole === "Admin" && (
                            <div style={{
                                padding: "16px 24px",
                                borderTop: "1px solid #e5e7eb",
                                backgroundColor: "#f9fafb",
                                borderBottomLeftRadius: "10px",
                                borderBottomRightRadius: "10px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end"
                            }}>
                                {!isSavingItemBulkUpdates ? (
                                    <button
                                        className="action-button save-button"
                                        disabled={!hasActiveBulkUpdates} 
                                        onClick={() => saveRegistrationsBulkChanges()}
                                        onMouseOver={(e) => {
                                            if (hasActiveBulkUpdates) e.currentTarget.style.backgroundColor = "#1557b0";
                                        }}
                                        onMouseOut={(e) => {
                                            if (hasActiveBulkUpdates) e.currentTarget.style.backgroundColor = "#1a73e8";
                                        }}
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            padding: "8px 24px",
                                            cursor: hasActiveBulkUpdates ? "pointer" : "not-allowed",
                                            transition: "all 0.2s ease-in-out",
                                            color: "#ffffff",
                                            border: "1px solid",
                                            borderColor: hasActiveBulkUpdates ? "#1a73e8" : "#9ca3af",
                                            backgroundColor: hasActiveBulkUpdates ? "#1a73e8" : "#9ca3af",
                                            opacity: hasActiveBulkUpdates ? 1 : 0.7,
                                            borderRadius: "6px",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            outline: "none"
                                        }}
                                    >
                                        Apply Changes
                                    </button>
                                ) : (
                                    <LoadingSpinnerImage />
                                )}

                                {/* Feedback Messages */}
                                <div style={{ minHeight: "24px", marginTop: "8px", fontSize: "14px" }}>
                                    {isShowingSaveMessageBulkUpdates && (
                                        <span style={{ color: "#059669", fontWeight: 500 }}>
                                            Save successful!
                                        </span>
                                    )}
                                    {errorBulk && (
                                        <span style={{ color: "#dc2626", fontWeight: 500 }}>
                                            "Assigned To" field must have a selected user
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ) : null}








            {isShowingConfirmSavePopup ?
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        justifyContent: "center",
                        zIndex: 1000,
                        overflowY: "auto",
                        alignItems: "flex-start"
                    }}
                >
                    <div
                        id="add-products-popup"
                        style={{
                            width: "50%",
                            zIndex: 1000,
                            border: "1px solid rgb(51, 51, 51)",
                            padding: "15px",
                            backgroundColor: "rgb(250, 250, 250)",
                            borderRadius: "10px",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                            margin: "120px auto 40px auto",
                        }}
                    >
                    <div style={{ display: "flex", marginBottom: "5px" }}>
                        <div style={{ width: "50%" }}>
                            <h3>Save changes</h3>
                        </div>

                        <div style={{ width: "50%", textAlign: "right" }}>
                            <button
                                onClick={() => setIsShowingConfirmSavePopup(false)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                }}
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    <div style={{ height: "100%", overflow: "auto", width: "100%" }}>


                        You can save the changes to the certificate only or you can also apply the changes to all of the registrations under this certificate.
                        <br /><br />
                        Please choose the option you prefer:

                        {/* CERTIFICATE SAVE BUTTON */}
                        {/* CERTIFICATE SAVE BUTTON */}
                        {/* CERTIFICATE SAVE BUTTON */}


                        {AppContext.userRole == "Admin" ? <>

                            <div id="buttom-bar" >

                                {/* FORMS BUTTONS */}

                                <div className="action-button-bar" style={{ marginTop: "10px" }}>

                                    <div className="action-button-bar-left">
                                        <button
                                            className="action-button cancel-button"
                                            onClick={() => setIsShowingConfirmSavePopup(false)}
                                        >
                                            Cancel
                                        </button></div>
                                    <div className="action-button-bar-center"></div>

                                    <div className="action-button-bar-right">

                                        {!isSavingItemBulkUpdates ? (
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>

                                                <button
                                                    className="action-button save-button"
                                                    onClick={() => saveCurrentItem({ bulkSaveToRegistrations: false })}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#1a73e8";
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#1a73e8";
                                                    }}
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        padding: "6px 14px",
                                                        cursor: "pointer",
                                                        transition: "all 0.2s ease-in-out",
                                                        color: "#ffffff",
                                                        border: "1px solid #1a73e8",
                                                        backgroundColor: "#1a73e8",
                                                        whiteSpace: "nowrap",
                                                        outline: "none"
                                                    }}
                                                >
                                                    Save Certificate Only
                                                </button>

                                                <button
                                                    className="action-button save-button"
                                                    onClick={() => saveCurrentItem({ bulkSaveToRegistrations: true })}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#1a73e8";
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#1a73e8";
                                                    }}
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        padding: "6px 14px",
                                                        cursor: "pointer",
                                                        transition: "all 0.2s ease-in-out",
                                                        color: "#ffffff",
                                                        border: "1px solid #1a73e8",
                                                        backgroundColor: "#1a73e8",
                                                        whiteSpace: "nowrap",
                                                        outline: "none"
                                                    }}
                                                >
                                                    Save Certificate and Apply to the Registrations
                                                </button>
                                            </div>
                                        ) : (
                                            <>
                                                <LoadingSpinnerImage />
                                            </>
                                        )}

                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{
                                                flex: 1,
                                                justifyContent: "right",
                                                display: "flex",
                                                alignItems: "center",
                                                marginTop: "10px",
                                            }}>
                                                {isShowingSaveMessageBulkUpdates ?
                                                    <span className="save-message-shown">
                                                        Save successful!
                                                    </span>
                                                    : null}
                                            </div>



                                        </div>


                                    </div>


                                </div>

                            </div>

                        </>

                            : null}




                    </div>

                </div>
                </div>
                : null}











            {isShowingDocumentAddPopup ?
                <UploadPdfPopup certificateId={AppContext.currentItem.Id} onSuccess={successDocumentUploaded} onClose={closeDocumentPopup} />
            : null}



        </>
    );
};












const ItemDetailsField_MultiSelect = ({ AppContext, fieldTitle, fieldId, fieldName, selectedItems = [], LOV = [], LOVIdField, LOVNameField, mandatory = false, noneIsAll = true, itemLink = null, forceIsEditing = null }) => {

    const [formState, setFormState] = useState({});
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [possibleValuesObject, setPossibleValuesObject] = useState({});

    const dropdownRefs = useRef({});


    useEffect(() => {
        const initialState = {};

        initialState[fieldName] = selectedItems;

        setFormState(initialState);

        let tmp = {
            Alias: fieldName,
            Name: "",
            Items: LOV.map(pv => ({
                Text: pv[LOVNameField],
                Value: pv[LOVIdField],
                Disabled: false,
                Group: null,
                Selected: false
            }))
        };

        setPossibleValuesObject(tmp);

    }, []);



    useEffect(() => {

        AppContext.setCurrentItem({ ...AppContext.currentItem, [fieldName]: formState[fieldName] });

    }, [formState]);


    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    return <>

        <div className="view-task-field">

            <div className="view-task-field-line">

                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{width: "100%", position: "relative"}}>

                        {isEditingField === false ? (

                            <>
                                {selectedItems.length == 0 ? 
                                    <span
                                        className={`editable-field-span`}
                                        onClick={(e) =>
                                            changeIsEditingField(true)
                                        }
                                    >
                                        <FieldTypes.ItemDetailsField_EmptyValue />    
                                    </span>
                                :
                                    <div className="selected-tags">
                                    
                                        {LOV.filter(item => selectedItems.includes(item[LOVIdField])).map((item, index) => (
                                            <span key={index} className="tag">
                                                {itemLink ? 
                                                    <a href={itemLink.replaceAll("[PARAM]", item[LOVIdField])} target="_blank">{item[LOVNameField]}</a>
                                                : 
                                                    <span>{item[LOVNameField]}</span>
                                                }
                                            </span>
                                        ))}

                                    </div>
                                }

                            </>

                        ) : (

                            <MultiSelectField field={possibleValuesObject}
                                formState={formState}
                                setFormState={setFormState}
                                fieldsConfig={[possibleValuesObject]}
                                searchValues={searchValues}
                                setSearchValues={setSearchValues}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownRefs={dropdownRefs}
                                noneIsAll={noneIsAll}
                                itemLink={itemLink}
                            />
                        )}



                    </div>

                </div>

            </div>

        </div>


    </>

}







const RegistrationsList = ({ AppContext, refresh, customButtons = null }) => {

    let legalManufacturerFilter = window.legalManufacturerId ? { legalManufacturerId: window.legalManufacturerId } : {};

    return <>
    
        <GenericDataTable
            columns={[
                {
                    key: "IdCheckbox",
                    label: "",
                    sortable: false,
                    type: "checkbox",
                    size: "60px",
                },

                {
                    key: "Id", label: "Registration", sortable: false, size: "120px",

                    render: ({ value }) => (
                        <div style={{ textAlign: "center", width: "93px" }}>
                        <a
                            href={`/your-medboard/country-registrations/registrations/?&registrationId=${value}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                backgroundColor: "#f7fafc", padding: "0px 6px", borderRadius: "5px", border: "1px solid #e2e8f0",
                                color: "#3182ce",
                                fontWeight: "500"
                            }}
                        >
                            Open ↗
                            </a> </div>
                    ),
                },

                {
                    key: "ProductId", label: "Product Code", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_ProductCodeLink value={{ ProductId: row.ProductId, ProductSKUCode: row.ProductSKUCode, Archived: row.Archived }} />
                    ),
                },

                {
                    key: "ProductName", label: "Product Name", sortable: true, size: "300px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "FamilyId", label: "Product Family", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_FamilyLink value={{ FamilyId: row.FamilyId, FamilyName: row.FamilyName }} />
                    ),
                },

                {
                    key: "UDI", label: "UDI", sortable: true, size: "150px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "CountryId", label: "Country", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_Country value={{ CountryId: row.CountryId, CountryName: row.CountryName, FlagLink: row.FlagLink }} />
                    ),
                },

                {
                    key: "RiskClass", label: "Risk Class", sortable: true, size: "100px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_RiskClass value={value} />
                    ),
                },

                {
                    key: "Status", label: "Registration Status", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_RegistrationsStatus value={value} />
                    ),
                },

                {
                    key: "CountryRepresentatives", label: "Country Representative", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_MultipleOperatorsRepresentatives value={{ CountryRepresentatives: row.CountryRepresentatives, CountryRepresentativesIds: row.CountryRepresentativesIds }} />
                    ),
                },

                {
                    key: "CountryDistributors", label: "Country Distributor", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_MultipleOperatorsDistributors value={{ CountryDistributors: row.CountryDistributors, CountryDistributorsIds: row.CountryDistributorsIds }} />
                    ),
                },

                {
                    key: "Importers", label: "Country Importer", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_MultipleOperatorsImporters value={{ Importers: row.Importers, ImportersIds: row.ImportersIds }} />
                    ),
                },

                {
                    key: "IssuedBy", label: "Registration Issued By", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "ExpiryDate", label: "Expiry Date", sortable: true, size: "150px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_SimpleDate value={value} />
                    ),
                },

                {
                    key: "Notes", label: "Notes", sortable: true, size: "300px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "Selling", label: "Selling", sortable: true, size: "100px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_CountryRegistrationSelling value={value} />
                    ),
                },

                {
                    key: "AssignedTo", label: "Assigned user", sortable: true, size: "150px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_User value={value} users={AppContext.users} />
                    ),
                },

                {
                    key: "Priority", label: "Priority", sortable: true, size: "100px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_RegistrationPriority value={value} />
                    ),
                },


            ]}
            //fetchUrl="/umbraco/api/RIMSRegistrations/Registrations/?search=&sortBy=Name&sortType=ASCENDING&page=1&tagIds=&returnAll=false&legalManufacturerId=null&="
            fetchUrl="/umbraco/api/RIMSRegistrations/CertificateRegistrations/"
            enableDelete={AppContext.userRole == "Admin" ? true : false}
            enableExport={true}
            deleteUrl="/umbraco/api/RIMSRegistrations/BulkRegistrations/?registrationIds="
            exportUrl="/umbraco/api/RIMSRegistrations/RegistrationsExport/?registrationIds="
            queryParams={{ certificateId: AppContext.currentItem.Id, ...legalManufacturerFilter }}
            exportFileName={`${AppContext.currentItem.Name}-registrations-export.xlsx`}
            rowTitleKey="ProductName"
            searchPlaceholder="Search Registrations"
            LoadingComponent={LoadingSpinnerImage}
            customButtons={customButtons}
            refresh={refresh}
            showTotalCount={true}
            totalCountUrl="/umbraco/api/RIMSRegistrations/CertificateRegistrationsCount/"
        />

    </>

}





const DocumentsList = ({ AppContext, refresh, setRefresh, customButtons = null }) => {
    const [deletingId, setDeletingId] = useState(null);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [dropdownCoords, setDropdownCoords] = useState({ top: 0, right: 0 });
    const toggleDropdown = (id) => {
        if (openDropdownId === id) {
            setOpenDropdownId(null);
        } else {
            setOpenDropdownId(id);
        }
    };
    const dropdownRef = useRef(null); 

    useEffect(() => {
        const handleClickOutside = (event) => {
            
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null); // Close the dropdown
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setOpenDropdownId]);


    const removeDocument = async (certificateFileId) => {
        try {
            setDeletingId(certificateFileId);

            await fetch(
                `/umbraco/api/RIMSRegistrations/Documents/?fileId=${certificateFileId}`,
                {
                    method: "DELETE"
                }
            );

            setRefresh(prev => prev + 1);
        }
        finally {
            setDeletingId(null);
            setConfirmDeleteId(null);
        }
    };
    const iconMap = {
        pdf: 'fas fa-file-pdf text-danger',
        doc: 'fas fa-file-word text-primary',
        docx: 'fas fa-file-word text-primary',
        xls: 'fas fa-file-excel text-success',
        xlsx: 'fas fa-file-excel text-success',
        ppt: 'fas fa-file-powerpoint text-warning',
        pptx: 'fas fa-file-powerpoint text-warning',
        png: 'fas fa-file-image text-info',
        jpg: 'fas fa-file-image text-info',
        jpeg: 'fas fa-file-image text-info',
        tiff: 'fas fa-file-image text-info',
        tif: 'fas fa-file-image text-info',
        ris: 'fas fa-file-alt text-info',
        txt: 'fas fa-file-alt text-info',
        csv: 'fas fa-file-alt text-success'
    };
    const getFileIcon = (filename) => {
        const ext = filename?.split('.').pop().toLowerCase();
        return iconMap[ext] || 'fa-file text-secondary'; 
    };
    return (
        <>
            <GenericDataTable
                columns={[
                    {
                        key: "Filename",
                        label: "Filename",
                        sortable: true,
                        size: "300px",
                        render: ({ row, value }) => {
                            const iconClass = getFileIcon(value);
                            return (
                                <>
                                    <i className={`${iconClass} g-mr-20 g-ml-10`}></i>
                                    <a
                                        href={`/umbraco/api/RIMSRegistrations/Document/?fileId=${row.CertificateFileId}&view=true`}
                                        title="View file"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
                                    >
                                        {value}
                                    </a>
                                </>
                            );
                        },
                    },
                    {
                        key: "FileSize",
                        label: "Filesize (Bytes)",
                        sortable: true,
                        size: "100px",
                        render: ({ value }) => <>{value}</>,
                    },
                    {
                        key: "UploadDate",
                        label: "Uploaded",
                        sortable: true,
                        size: "200px",
                        render: ({ row, value }) => {
                            if (!value) return <></>;
                            return <>{new Date(value).toLocaleDateString(undefined, { timeZone: "UTC", year: 'numeric', month: 'short', day: 'numeric' })}</>;
                        },
                    },

                    {
                        key: "UploadedBy",
                        label: "Uploaded By",
                        sortable: true,
                        size: "150px",
                        render: ({ row, value }) => (
                            <FieldTypes.FieldType_User
                                value={value}
                                users={AppContext.users}
                            />
                        ),
                    },

                    {
                        key: "CertificateFileId",
                        label: "Options",
                        sortable: true,
                        size: "100px",
                        render: ({ row, value }) => {
                            const fileExtension = row.Filename?.split('.').pop()?.toLowerCase();
                            const isPdf = fileExtension === 'pdf';

                            return (
                                <div ref={openDropdownId === value ? dropdownRef : null}>
                                    <span
                                        title="More options"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const rect = e.currentTarget.getBoundingClientRect();
                                            setDropdownCoords({
                                                top: rect.bottom + 4,
                                                right: window.innerWidth - rect.right
                                            });
                                            toggleDropdown(value);
                                        }}
                                        style={{ cursor: "pointer", padding: "4px 8px" }}
                                    >
                                        <i className="fas fa-ellipsis-v"></i>
                                    </span>

                                    {openDropdownId === value && (
                                        <div style={{
                                            position: "fixed",
                                            right: `${dropdownCoords.right}px`,
                                            top: `${dropdownCoords.top}px`,
                                            backgroundColor: 'white',
                                            border: '1px solid #ccc',
                                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                            zIndex: 9999,
                                            borderRadius: "5px",
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column",
                                            minWidth: "160px"
                                        }}>
                                            {isPdf && (
                                                <a
                                                    href={`/umbraco/api/RIMSRegistrations/Document/?fileId=${value}&view=true`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="submissions-dropdown-item"
                                                    style={{ textDecoration: "none", padding: "8px 12px", color: "inherit", display: "flex", alignItems: "center" }}
                                                >
                                                    <i className="fas fa-eye" style={{ marginRight: "10px", width: "16px", textAlign: "center" }}></i> View file
                                                </a>
                                            )}

                                            <a
                                                href={`/umbraco/api/RIMSRegistrations/Document/?fileId=${value}`}
                                                className="submissions-dropdown-item"
                                                style={{ textDecoration: "none", padding: "8px 12px", color: "inherit", display: "flex", alignItems: "center" }}
                                            >
                                                <i className="fas fa-download" style={{ marginRight: "10px", width: "16px", textAlign: "center" }}></i> Download
                                            </a>

                                            {AppContext.userRole === "Admin" && (
                                                deletingId === value ? (
                                                    <div className="submissions-dropdown-item" style={{ padding: "8px 12px", display: "flex", alignItems: "center" }}>
                                                        <LoadingSpinnerImage small={true} />
                                                        <span style={{ marginLeft: "10px" }}>Deleting...</span>
                                                    </div>
                                                ) : (
                                                    <span
                                                        onClick={() => {
                                                            setConfirmDeleteId(value);
                                                            setOpenDropdownId(null);
                                                        }}
                                                        className="submissions-dropdown-item"
                                                        style={{ cursor: "pointer", padding: "8px 12px", color: "inherit", display: "flex", alignItems: "center" }}
                                                    >
                                                        <i className="fas fa-times-circle" style={{ marginRight: "10px", width: "16px", textAlign: "center" }}></i> Delete
                                                    </span>
                                                )
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    },
                ]}
                fetchUrl="/umbraco/api/RIMSRegistrations/Documents/"
                enableDelete={AppContext.userRole == "Admin" ? true : false}
                enableExport={false}
                queryParams={{
                    entityId: AppContext.currentItem.Id,
                    docType: "certificates"
                }}
                exportFileName={`${AppContext.currentItem.Name}-documents-export.xlsx`}
                rowTitleKey="ProductName"
                rowIdKey="CertificateFileId"
                searchPlaceholder="Search Documents"
                LoadingComponent={LoadingSpinnerImage}
                customButtons={customButtons}
                refresh={refresh}
                showTotalCount={true}
                totalCountUrl="/umbraco/api/RIMSRegistrations/DocumentsCount/"

            />

            {/* CONFIRMATION MODAL */}
            {confirmDeleteId && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            width: "320px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
                        }}
                    >
                        <h3 style={{ marginTop: 0 }}>Confirm Delete</h3>

                        <p style={{ marginBottom: "20px" }}>
                            Are you sure you want to delete this document?
                        </p>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button
                                onClick={() => setConfirmDeleteId(null)}
                                style={{
                                    padding: "6px 12px",
                                    border: "1px solid #ccc",
                                    background: "#fff",
                                    cursor: "pointer",
                                    borderRadius: "4px"
                                }}
                                disabled={deletingId === confirmDeleteId}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => removeDocument(confirmDeleteId)}
                                style={{
                                    padding: "6px 12px",
                                    border: "none",
                                    background: "#d11a2a",
                                    color: "#fff",
                                    cursor: "pointer",
                                    borderRadius: "4px"
                                }}
                                disabled={deletingId === confirmDeleteId}
                            >
                                {deletingId === confirmDeleteId ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};









const CertificateHistory = ({ certificateId, users = [], openTab }) => {

    const [activity, setActivity] = useState([]);
    const [loading, setLoading] = useState(true);

    
    const CertificateAuditActionType = {
        Edited: 0,
        Created: 1,
        UpdatedNotes: 2,
        AddedDocument: 3,
        RemovedDocument: 4,
        DownloadedDocument: 5,
        AddedProduct: 6,
        RemovedProduct: 7,
        AddedActivity: 8,
        DeletedCertificate: 9,
        DeletedEstablishment: 10,
        UpdatedOperatorContacts: 11,
        UpdatedOperatorIdentifiers: 12,
        UpdatedOperatorCertificateSettings: 13,
        UpdatedAlerts: 14,
        UpdateBulkCertificate: 15

    };

    const actionTitles = {
        [CertificateAuditActionType.Edited]: "Edited",
        [CertificateAuditActionType.Created]: "Created",
        [CertificateAuditActionType.UpdatedNotes]: "Updated Notes",
        [CertificateAuditActionType.AddedDocument]: "Added Document",
        [CertificateAuditActionType.RemovedDocument]: "Removed Document",
        [CertificateAuditActionType.DownloadedDocument]: "Downloaded Document",
        [CertificateAuditActionType.AddedProduct]: "Added Product",
        [CertificateAuditActionType.RemovedProduct]: "Removed Product",
        [CertificateAuditActionType.AddedActivity]: "New Comment.",
        [CertificateAuditActionType.DeletedCertificate]: "Deleted Certificate",
        [CertificateAuditActionType.DeletedEstablishment]: "Deleted Operator",
        [CertificateAuditActionType.UpdatedOperatorContacts]: "Updated Contacts",
        [CertificateAuditActionType.UpdatedOperatorIdentifiers]: "Updated Identifiers",
        [CertificateAuditActionType.UpdatedOperatorCertificateSettings]: "Updated Certificate Settings",
        [CertificateAuditActionType.UpdatedAlerts]: "Updated Assign User, Priority & Alerts",
        [CertificateAuditActionType.UpdateBulkCertificate]: "Updated Bulk Settings",
    };

    const getDescription = (item) => {
        switch (item.Type) {
            case CertificateAuditActionType.Edited:
                return "Edited this certificate's properties";

            case CertificateAuditActionType.Created:
                return "Created this certificate";

            case CertificateAuditActionType.UpdatedNotes:
                return "Updated this certificate's notes";

            case CertificateAuditActionType.AddedDocument:
                return `Uploaded a new document: ${item.ExtraDetails}`;

            case CertificateAuditActionType.RemovedDocument:
                return `Removed a document: ${item.ExtraDetails}`;

            case CertificateAuditActionType.DownloadedDocument:
                return `Downloaded a document: ${item.ExtraDetails}`;

            case CertificateAuditActionType.AddedProduct:
                return `Added a new product to this certificate ${item.ExtraDetails}`;

            case CertificateAuditActionType.RemovedProduct:
                return `Removed a product from this certificate ${item.ExtraDetails}`;

            case CertificateAuditActionType.AddedActivity:
                return "Added a comment in activity.";

            case CertificateAuditActionType.DeletedCertificate:
                return "Deleted this certificate.";

            case CertificateAuditActionType.DeletedEstablishment:
                return "Deleted this operator.";

            case CertificateAuditActionType.UpdatedOperatorContacts:
                return "Updated this operator's contacts";

            case CertificateAuditActionType.UpdatedOperatorIdentifiers:
                return "Updated this operator's identifiers";

            case CertificateAuditActionType.UpdatedOperatorCertificateSettings:
                return "Updated this operator's certificate settings";

            case CertificateAuditActionType.UpdatedAlerts:
                return "Updated this certificate's assigned user, alerts and priority";

            case CertificateAuditActionType.UpdateBulkCertificate:
                return "Updated this certificate's bulk settings";

            default:
                return item.Type;
        }
    };

    const formatDate = (date) => {
        if (!date) return "";

        return new Date(date).toLocaleString();
    };


    useEffect(() => {
        if (!certificateId) return;

        const loadHistory = async () => {
            try {
                setLoading(true);

                const response = await fetch(
                    `/umbraco/api/RIMSRegistrations/History/?certificateId=${certificateId}`
                );

                if (!response.ok) {
                    throw new Error("Failed to load history");
                }

                const data = await response.json();

                setActivity(data || []);
            } catch (error) {
                console.error("Error loading operator history:", error);
            } finally {
                setLoading(false);
            }
        };

        loadHistory();
    }, [certificateId]);

    const orderedActivity = useMemo(() => {
        return [...activity].sort(
            (a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt)
        );
    }, [activity]);

    const getUser = (authorId) => {
        return users.find((x) => x.id === authorId || x.Id === authorId);
    };

    return (
        <div>
            {loading && <div><LoadingSpinnerImage /></div>}

            {!loading && !orderedActivity.length && (
                <p>No history exists yet for this certificate.</p>
            )}

            {!loading &&
                orderedActivity.map((item) => {
                    const user = getUser(item.Author);

                    return (
                        <section
                            className="g-pos-rel g-left-25--before"
                            key={item.AuditEntryId}
                        >
                            <div className="g-orientation-left g-pos-rel g-ml-25--md g-pl-20">
                                <div className="g-hidden-sm-down u-timeline-v2__icon g-top-35">
                                    <i className="d-block g-width-16 g-height-16 g-bg-white g-brd-around g-brd-2 g-brd-secondary rounded-circle"></i>
                                </div>

                                <div className="media">
                                    <div className="d-flex align-self-center g-mr-15">
                                        <FieldTypes.FieldType_User value={item.Author} users={users} />
                                    </div>

                                    <div className="media-body align-self-center">
                                        <h3 className="g-font-weight-300 g-font-size-16 g-mb-3">
                                            {user?.Name || "Unknown User"}
                                        </h3>

                                        <em className="g-font-style-normal g-color-secondary">
                                            {actionTitles[item.Type] || item.Type}
                                        </em>
                                    </div>

                                    <div className="d-flex align-self-center g-mr-15">
                                        {formatDate(item.CreatedAt)}
                                    </div>
                                </div>

                                <p className="g-font-weight-300 g-font-size-default">
                                    {getDescription(item)}
                                </p>
                            </div>

                            <hr className="d-flex g-brd-gray-light-v4 g-ml-35--md g-my-20 g-my-30--md" />
                        </section>
                    );
                })}
        </div>
    );
};





const UploadPdfPopup = ({ certificateId, onClose, onSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isDragging, setIsDragging] = useState(false); // Track drag state

    const fileInputRef = useRef(null);

    // --- Drag and Drop Handlers ---
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setSelectedFile(e.dataTransfer.files[0]);
            setError(""); // Reset any previous errors
            e.dataTransfer.clearData();
        }
    };
    // ------------------------------

    const handleUpload = async () => {
        if (!selectedFile) {
            setError("Please select a file.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            const response = await fetch(
                `/umbraco/api/RIMSRegistrations/Documents?certificateId=${certificateId}`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (!response.ok) {
                throw new Error("Upload failed");
            }

            setSelectedFile(null);

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }

            if (onSuccess) onSuccess();
            if (onClose) onClose();
        } catch (err) {
            console.error(err);
            setError("Failed to upload file.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            id="add-pdf-popup"
            style={{
                position: "fixed",
                left: 0,
                right: 0,
                top: "120px",
                width: "90%",
                maxWidth: "400px",
                margin: "0 auto",
                zIndex: 1000,
                padding: "24px",
                border: "1px solid rgb(224, 224, 224)",
                borderRadius: "12px",
                backgroundColor: "rgb(255, 255, 255)",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px",
                fontFamily: "sans-serif"
            }}
        >
            {/* Header Section */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "rgb(55, 65, 81)" }}>
                    Upload File
                </h3>
                <button
                    onClick={onClose}
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "rgb(156, 163, 175)",
                        padding: "4px",
                        transition: "color 0.2s"
                    }}
                    onMouseEnter={(e) => e.target.style.color = "rgb(75, 85, 99)"}
                    onMouseLeave={(e) => e.target.style.color = "rgb(156, 163, 175)"}
                >
                    ✕
                </button>
            </div>

            {/* Drag & Drop Styled Label */}
            <label
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "30px 20px",
                    border: "2px dashed",
                    borderColor: isDragging ? "#3498db" : "rgb(209, 213, 219)", // Reacts to drag state
                    borderRadius: "8px",
                    cursor: "pointer",
                    backgroundColor: isDragging ? "rgb(243, 244, 246)" : "rgb(249, 250, 251)", // Reacts to drag state
                    transition: "0.2s"
                }}
                onMouseEnter={(e) => { if (!isDragging) e.currentTarget.style.backgroundColor = "rgb(243, 244, 246)" }}
                onMouseLeave={(e) => { if (!isDragging) e.currentTarget.style.backgroundColor = "rgb(249, 250, 251)" }}
            >
                <i className="fas fa-upload" style={{ fontSize: "24px", color: isDragging ? "#3498db" : "rgb(156, 163, 175)", marginBottom: "8px" }}></i>
                <span style={{ textAlign: "center", fontSize: "14px", color: "rgb(75, 85, 99)" }}>
                    {selectedFile ? selectedFile.name : "Click to select a file or drag and drop"}
                </span>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="application/pdf, 
                    application/msword, 
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
                    application/vnd.ms-excel, 
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/*,
                    text/plain,
                    text/csv,
                    .ris"
                    onChange={(e) => {
                        setSelectedFile(e.target.files ? e.target.files[0] : null);
                        setError(""); // Clear error on new manual selection
                    }}
                    style={{ display: "none" }}
                />
            </label>

            {/* Action Button Section */}
            <div style={{ textAlign: "center" }}>
                <button
                    disabled={loading || !selectedFile}
                    onClick={handleUpload}
                    className="btn u-btn-blue g-font-size-13 g-pl-12 g-pr-12 g-pt-8 g-pb-8"
                    style={{
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: (loading || !selectedFile) ? "not-allowed" : "pointer",
                        opacity: (loading || !selectedFile) ? 0.6 : 1,
                        borderWidth: "medium",
                        borderStyle: "none",
                        borderColor: "currentcolor",
                        borderImage: "initial",
                        width: "100%",
                        transition: "background 0.2s",
                        padding: "10px 16px",
                        fontSize: "14px",
                        fontWeight: "500"
                    }}
                >
                    <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-arrow-up"}></i>
                    {loading ? "Uploading..." : "Submit"}
                </button>
            </div>

            {/* Error Message */}
            {error && (
                <div style={{ color: "#dc2626", fontSize: "13px", marginTop: "-10px", textAlign: "center" }}>
                    {error}
                </div>
            )}
        </div>
    );
};





const CommentsPanel = ({ AppContext, certificateId, user }) => {
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);
    const [posting, setPosting] = useState(false);

    useEffect(() => {
        if (!certificateId) return;
        fetchComments();
    }, [certificateId]);

    async function fetchComments() {
        setLoading(true);
        try {
            const res = await fetch(
                `/umbraco/api/RIMSRegistrations/Comments?certificateId=${certificateId}`
            );

            const data = await res.json();

            // filter empty comments (you have these in API)
            //const cleaned = (data || []).filter((c) => c.Comment?.trim());

            setComments(data);
        } catch (err) {
            console.error("Failed to load comments", err);
        } finally {
            setLoading(false);
        }
    }

    async function handleAddComment() {
        if (!comment.trim()) return;

        setPosting(true);
        try {
            await fetch(
                `/umbraco/api/RIMSRegistrations/Comments?certificateId=${certificateId}&comment=${encodeURIComponent(
                    comment
                )}`,
                { method: "POST" }
            );

            setComment("");
            await fetchComments();
        } catch (err) {
            console.error("Failed to post comment", err);
        } finally {
            setPosting(false);
        }
    }

    function formatDate(iso) {
        if (!iso) return "";
        return new Date(iso).toLocaleString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    }


    let userId = AppContext.users?.find(user => user.IsItMe)?.Id;

    return (
        <div style={{ marginBottom: 20 }}>
            {/* ADD COMMENT */}
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div>
                    <FieldTypes.FieldType_User value={userId} users={AppContext.users} />
                </div>

                <div style={{ flex: 1, marginLeft: 10 }}>
                    <textarea
                        style={{ width: "100%" }}
                        className="addCommentTextBox form-field-text"
                        placeholder="Add a comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />

                    <div style={{ marginTop: 10 }}>
                        <button
                            className="action-button save-button"
                            onClick={handleAddComment}
                            disabled={posting}
                        >
                            {posting ? "Saving..." : "Save comment"}
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 20 }} />

            {/* LIST */}
            <div style={{ maxHeight: "100vh", overflow: "auto", paddingRight: 10 }}>
                {loading ? (
                    <div><LoadingSpinnerImage /></div>
                ) : (
                    comments.map((c) => (
                        <div key={c.NoteId}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <div>
                                    <FieldTypes.FieldType_User value={c.Author} users={AppContext.users} />
                                </div>

                                <div style={{ flex: 1, marginLeft: 10 }}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div style={{ fontWeight: "bold" }}>
                                            {AppContext.users?.find(user => user.Id == c.Author)?.Name}
                                        </div>

                                        <div style={{ color: "#a8a8a8" }}>
                                            {formatDate(c.CreatedAt)}
                                        </div>
                                    </div>

                                    <div>{c.Comment}</div>
                                </div>
                            </div>

                            <div
                                style={{
                                    marginTop: 20,
                                    borderTop: "1px solid #f3f3f3",
                                    marginBottom: 20,
                                }}
                            />
                        </div>
                    ))
                )}

                {!loading && comments.length === 0 && (
                    <div>No more comments</div>
                )}
            </div>
        </div>
    );
};



const ErrorBullet = ({ error }) => {

    return <>
        {error ? 
            <div style={{
                color: "rgb(255, 84, 0)",
                display: "inline-flex",
                alignItems: "center",
                padding: "6px 14px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
                border: "1px solid rgb(222, 226, 230)",
                whiteSpace: "nowrap",
                outline: "none",
                borderRadius: "15px",
                backgroundColor: "#fff2f2",
            }}>
                { error }
            </div>
        : null }
    </>

}


export default ItemDetailsPane;